var _script, _script2, _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrvLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 556.981,
    viewBox: "0 0 414.432 417.736",
    width: 552.576,
    id: "svg3329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    id: "argent-x-extension",
    "data-extension-id": "dlcobpjiigpikoobohmabehhmhfoodbb"
  })), _script2 || (_script2 = /*#__PURE__*/React.createElement("script", {
    type: "text/javascript"
  })), /*#__PURE__*/React.createElement("defs", {
    id: "defs4",
    style: {
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    }
  }, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "*{stroke-linecap:butt;stroke-linejoin:round}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    id: "axes_1",
    transform: "translate(-407.371 -238.93)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    id: "Poly3DCollection_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path279",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m583.646 492.368-31.64 6.965-3.925-14.799 33.604-6.147z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path281",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m552.005 499.333-27.493 9.333-5.94-15.45 29.509-8.682z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path283",
    style: {
      fill: "#0028ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m581.685 478.387-33.604 6.147-3.534-17.27 35.381-5.218z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path285",
    style: {
      fill: "#0018ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m548.08 484.534-29.508 8.682-5.359-18.029 31.334-7.922z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path287",
    style: {
      fill: "#0000f1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m585.765 503.65-29.539 7.654-4.22-11.971 31.64-6.965z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path289",
    style: {
      fill: "#0000da",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m556.226 511.304-25.333 9.862-6.38-12.5 27.492-9.333z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path291",
    style: {
      fill: "#0058ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m579.928 462.046-35.381 5.219-3.058-19.33 36.93-4.201z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path293",
    style: {
      fill: "#0048ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m544.547 467.265-31.334 7.922-4.647-20.18 32.923-7.072z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path295",
    style: {
      fill: "#0014ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m618.227 487.776-34.581 4.592-1.961-13.98 36.411-3.64z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path297",
    style: {
      fill: "#0000da",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m587.99 511.954-27.348 8.2-4.416-8.85 29.539-7.655z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path299",
    style: {
      fill: "#0000e8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m524.512 508.666-22.54 11.559-7.919-15.905 24.519-11.104z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path301",
    style: {
      fill: "#0000c4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m560.642 520.154-23.08 10.256-6.669-9.244 25.333-9.862z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path303",
    style: {
      fill: "#003cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m618.096 474.748-36.411 3.64-1.757-16.342 38.07-2.576z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path305",
    style: {
      fill: "#0008ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m518.572 493.216-24.519 11.104-7.148-18.59 26.308-10.543z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path307",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m618.387 498.24-32.622 5.41-2.12-11.282 34.582-4.592z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path309",
    style: {
      fill: "#0000c8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m530.893 521.166-20.42 11.9-8.5-12.841 22.54-11.559z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path311",
    style: {
      fill: "#0090ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m578.42 443.734-36.931 4.201-2.507-20.929 38.214-3.116z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path313",
    style: {
      fill: "#0084ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m541.489 447.935-32.923 7.072-3.821-21.853 34.237-6.148z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path315",
    style: {
      fill: "#0068ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m617.998 459.47-38.07 2.576-1.508-18.312 39.515-1.424z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path317",
    style: {
      fill: "#003cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m513.213 475.187-26.308 10.543-6.204-20.835 27.865-9.888z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path319",
    style: {
      fill: "#0000f6",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m618.573 505.88-30.583 6.074-2.225-8.305 32.622-5.41z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path321",
    style: {
      fill: "#0000d1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m590.268 517.07-25.12 8.585-4.506-5.501 27.348-8.2z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path323",
    style: {
      fill: "#0000ad",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m537.562 530.41-18.207 12.117-8.881-9.462 20.42-11.899z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path325",
    style: {
      fill: "#00b",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m565.148 525.655-20.789 10.505-6.797-5.75 23.08-10.256z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path327",
    style: {
      fill: "#009cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m617.935 442.31-39.515 1.424-1.224-19.844 40.713-.21z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path329",
    style: {
      fill: "#0078ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m508.566 455.007-27.865 9.888-5.108-22.589 29.152-9.152z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path331",
    style: {
      fill: "#0000ed",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m618.78 510.5-28.512 6.57-2.278-5.116 30.583-6.074z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path333",
    style: {
      fill: "#0cf",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m577.196 423.89-38.214 3.116-1.891-22.03 39.197-1.987z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path335",
    style: {
      fill: "#002cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m654.195 485.447-35.968 2.33-.131-13.029 37.6-1.28z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path337",
    style: {
      fill: "#00c4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m538.982 427.006-34.237 6.148-2.898-23.007 35.244-5.17z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path339",
    style: {
      fill: "#0014ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m652.61 494.998-34.223 3.242-.16-10.464 35.968-2.33z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path341",
    style: {
      fill: "#0050ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m655.696 473.467-37.6 1.281-.098-15.278 39.08-.118z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path343",
    style: {
      fill: "#0000da",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m501.973 520.225-17.208 13.501-9.763-16.143 19.051-13.263z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path345",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m494.053 504.32-19.051 13.263-8.816-18.93 20.72-12.923z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path347",
    style: {
      fill: "#0000a4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m544.359 536.16-15.955 12.208-9.05-5.841 18.208-12.117z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path349",
    style: {
      fill: "#0000b6",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m510.474 533.065-15.23 13.633-10.479-12.972 17.208-13.501Z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path351",
    style: {
      fill: "#0000d6",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m592.544 518.854-22.91 8.801-4.486-2 25.12-8.585z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path353",
    style: {
      fill: "#0004ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m650.981 501.887-32.408 3.993-.186-7.64 34.223-3.242z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path355",
    style: {
      fill: "#0078ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m657.077 459.352-39.079.118-.063-17.16 40.37 1.13z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path357",
    style: {
      fill: "#0000bf",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m569.633 527.655-18.513 10.603-6.761-2.098 20.789-10.505z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path359",
    style: {
      fill: "#00d8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m617.91 423.68-40.714.21-.908-20.901 41.633 1.04z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path361",
    style: {
      fill: "#0034ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m486.905 485.73-20.719 12.923-7.655-21.27 22.17-12.488z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path363",
    style: {
      fill: "#0000f1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m619.004 511.976-26.46 6.878-2.276-1.784 28.512-6.57z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path365",
    style: {
      fill: "#00009f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m519.355 542.527-13.167 13.656-10.944-9.485 15.23-13.633z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path367",
    style: {
      fill: "#00bcff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m504.745 433.154-29.152 9.152-3.882-23.805 30.136-8.354z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path369",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "M649.347 505.936 618.78 510.5l-.207-4.621 32.408-3.993z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path371",
    style: {
      fill: "#23ffd4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m576.288 402.989-39.197 1.988-1.226-22.599 39.856-.84z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path373",
    style: {
      fill: "#00acff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m658.304 443.44-40.369-1.13-.026-18.63 41.438 2.438z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path375",
    style: {
      fill: "#1cffdb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m537.09 404.977-35.243 5.17-1.898-23.607 35.916-4.162z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path377",
    style: {
      fill: "#0000ad",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m551.12 538.258-13.717 12.168-9-2.058 15.956-12.208z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path379",
    style: {
      fill: "#0070ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m480.7 464.895-22.169 12.488-6.306-23.11 23.368-11.967z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path381",
    style: {
      fill: "#0000e8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m594.762 517.24-20.773 8.84-4.356 1.575 22.911-8.801z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path383",
    style: {
      fill: "#000096",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m528.404 548.368-11.067 13.571-11.15-5.756 13.168-13.656z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path385",
    style: {
      fill: "#26ffd1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m617.921 404.028-41.633-1.039-.567-21.452 42.25 2.297z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path387",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m647.748 507.035-28.744 4.94-.224-1.474 30.567-4.565z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path389",
    style: {
      fill: "#04f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m689.741 485.166-35.546.28 1.5-11.979 36.932.828z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path391",
    style: {
      fill: "#002cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m686.678 493.751-34.068 1.247 1.585-9.551 35.546-.28z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path393",
    style: {
      fill: "#0000d1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m573.989 526.08-16.308 10.544-6.56 1.634 18.512-10.603z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path395",
    style: {
      fill: "#00e0fb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m659.347 426.118-41.438-2.438.012-19.652 42.258 3.776z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path397",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m619.238 510.249-24.476 6.992-2.218 1.613 26.46-6.878z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path399",
    style: {
      fill: "#0064ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m692.627 474.295-36.931-.828 1.381-14.115 38.186 2.049z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path401",
    style: {
      fill: "#19ffde",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m501.847 410.147-30.136 8.354-2.553-24.453 30.791-7.508z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path403",
    style: {
      fill: "#001cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m683.511 499.837-32.53 2.05 1.63-6.889 34.067-1.247z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path405",
    style: {
      fill: "#0000d1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m484.765 533.726-11.911 15.02-11.377-16.149 13.525-15.014z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path407",
    style: {
      fill: "#0000a8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m495.244 546.698-10.182 14.931-12.208-12.883 11.912-15.02z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path409",
    style: {
      fill: "#5aff9d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m575.721 381.537-39.856.841-.524-22.615 40.17.299z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path411",
    style: {
      fill: "#008cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m695.263 461.4-38.186-2.048 1.227-15.911 39.28 3.356z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path413",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m475.002 517.583-13.525 15.014-10.276-19.033 14.985-14.91z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path415",
    style: {
      fill: "#00b8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m475.593 442.307-23.368 11.966-4.795-24.403 24.28-11.37Z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path417",
    style: {
      fill: "#5aff9d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m535.865 382.378-35.916 4.162-.842-23.633 36.234-3.144z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path419",
    style: {
      fill: "#0018ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m680.318 503.268-30.971 2.668 1.634-4.05 32.53-2.05z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path421",
    style: {
      fill: "#0000bf",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m557.68 536.624-11.548 11.997-8.729 1.805 13.717-12.168z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path423",
    style: {
      fill: "#00009b",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m537.403 550.426-8.98 13.38-11.086-1.867 11.067-13.571z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path425",
    style: {
      fill: "#000092",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m506.188 556.183-8.378 14.75-12.748-9.304 10.182-14.931z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path427",
    style: {
      fill: "#000cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m646.224 505.14-26.986 5.109-.234 1.727 28.744-4.941z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path429",
    style: {
      fill: "#002cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m466.186 498.653-14.985 14.911-8.924-21.469 16.254-14.712z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path431",
    style: {
      fill: "#5dff9a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m617.97 383.834-42.249-2.297-.21-21.475 42.545 3.532z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path433",
    style: {
      fill: "#2cffca",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m660.179 407.804-42.258-3.776.05-20.194 42.806 5.112z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path435",
    style: {
      fill: "#00b8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m697.584 446.797-39.28-3.356 1.043-17.323 40.186 4.72z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path437",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m596.866 512.241-18.76 8.694-4.117 5.144 20.773-8.838z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path439",
    style: {
      fill: "#000cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m619.477 505.339-22.611 6.902-2.104 5 24.476-6.992z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path441",
    style: {
      fill: "#0018ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m677.179 503.953-29.431 3.082 1.599-1.1 30.972-2.667z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path443",
    style: {
      fill: "#0000f1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m578.106 520.935-14.23 10.328-6.195 5.36 16.308-10.544z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path445",
    style: {
      fill: "#56ffa0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m499.95 386.54-30.792 7.508-1.147-24.503 31.096-6.638z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path447",
    style: {
      fill: "#000089",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m517.337 561.94-6.543 14.483-12.984-5.49 8.378-14.75z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path449",
    style: {
      fill: "#006cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m458.531 477.383-16.254 14.712-7.352-23.4 17.3-14.422z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path451",
    style: {
      fill: "#16ffe1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m471.71 418.5-24.28 11.37-3.157-25.11 24.885-10.712Z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path453",
    style: {
      fill: "#06ecf1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m699.533 430.839-40.186-4.721.832-18.314 40.88 6.11z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path455",
    style: {
      fill: "#94ff63",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m575.512 360.062-40.17-.3.196-22.068 40.13 1.403z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path457",
    style: {
      fill: "#0024ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m644.813 500.28-25.336 5.059-.24 4.91 26.987-5.108z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path459",
    style: {
      fill: "#0000ad",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m546.132 548.62-6.956 13.091-10.753 2.096 8.98-13.381z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path461",
    style: {
      fill: "#04f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m718.677 494.254-32-.503 3.064-8.585 33.182 1.488z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path463",
    style: {
      fill: "#005cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m722.923 486.654-33.182-1.488 2.886-10.871 34.288 2.614z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path465",
    style: {
      fill: "#5dff9a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m660.777 388.946-42.807-5.112.086-20.24 43.07 6.418z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path467",
    style: {
      fill: "#94ff63",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m535.341 359.763-36.234 3.144.245-23.07 36.186-2.143z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path469",
    style: {
      fill: "#0028ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m674.17 501.86-27.946 3.28 1.524 1.895 29.431-3.082z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path471",
    style: {
      fill: "#0000df",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m563.876 531.263-9.501 11.699-8.243 5.659 11.549-11.997z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path473",
    style: {
      fill: "#0038ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m714.281 499.52-30.77.317 3.167-6.086 31.999.503z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path475",
    style: {
      fill: "#0078ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m726.915 476.91-34.288-2.615 2.636-12.894 35.29 3.855z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path477",
    style: {
      fill: "#90ff66",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m618.056 363.594-42.544-3.532.156-20.965 42.509 4.72z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path479",
    style: {
      fill: "#00008d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m528.423 563.807-4.72 14.139-12.91-1.523 6.544-14.484z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path481",
    style: {
      fill: "#001cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m598.803 503.95-16.924 8.365-3.773 8.62 18.76-8.694z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path483",
    style: {
      fill: "#0034ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m709.845 502.32-29.527.948 3.193-3.431 30.77-.317z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path485",
    style: {
      fill: "#0030ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m619.716 497.341-20.913 6.61-1.937 8.29 22.611-6.902z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path487",
    style: {
      fill: "#00a0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m730.554 465.256-35.291-3.855 2.321-14.604 36.165 5.183z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path489",
    style: {
      fill: "#33ffc4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m701.059 413.915-40.88-6.111.598-18.858 41.344 7.495z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path491",
    style: {
      fill: "#00b0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m452.225 454.273-17.3 14.422-5.591-24.779 18.096-14.046Z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path493",
    style: {
      fill: "#0000c8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m472.854 548.746-7.03 15.989-12.672-15.92 8.325-16.218z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path495",
    style: {
      fill: "#0000a4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m485.062 561.63-5.646 15.675-13.593-12.57 7.031-15.989z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path497",
    style: {
      fill: "#0008ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m581.879 512.315-12.331 9.956-5.672 8.992 14.23-10.328z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path499",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m461.477 532.597-8.325 16.219-11.445-18.892 9.494-16.36z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path501",
    style: {
      fill: "#94ff63",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m499.107 362.907-31.096 6.638.3-23.947 31.04-5.761z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path503",
    style: {
      fill: "#0034ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m705.477 502.577-28.298 1.376 3.14-.685 29.526-.948z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path505",
    style: {
      fill: "#003cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m671.369 497.027-26.556 3.253 1.41 4.86 27.947-3.28z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path507",
    style: {
      fill: "#56ffa0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m469.158 394.048-24.885 10.711-1.425-25.207 25.163-10.007z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path509",
    style: {
      fill: "#000089",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m497.81 570.933-4.204 15.291-14.19-8.919 5.646-15.676z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path511",
    style: {
      fill: "#04f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m643.551 492.553-23.835 4.788-.239 7.998 25.336-5.059z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path513",
    style: {
      fill: "#00c8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m733.75 451.98-36.166-5.183 1.95-15.958 36.887 6.564z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path515",
    style: {
      fill: "#90ff66",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m661.126 370.012-43.07-6.418.121-19.778 43.038 7.662z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path517",
    style: {
      fill: "#caff2c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m575.668 339.097-40.13-1.403.921-20.962 39.73 2.447z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path519",
    style: {
      fill: "#0000cd",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m554.375 542.962-5.046 12.704-10.153 6.045 6.956-13.09z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path521",
    style: {
      fill: "#0028ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m451.201 513.564-9.494 16.36-9.942-21.421 10.512-16.408z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path523",
    style: {
      fill: "#ceff29",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m535.538 337.694-36.186 2.143 1.338-21.922 35.77-1.183z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path525",
    style: {
      fill: "#c7ff30",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m618.177 343.816-42.51-4.719.522-19.918 42.14 5.826z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path527",
    style: {
      fill: "#00009f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m539.176 561.71-2.952 13.727-12.52 2.509 4.719-14.14z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path529",
    style: {
      fill: "#60ff97",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m702.121 396.44-41.344-7.494.35-18.934 41.563 8.84z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path531",
    style: {
      fill: "#0040ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m701.287 500.276-27.117 1.584 3.009 2.093 28.298-1.376z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path533",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m569.548 522.271-7.629 11.278-7.544 9.413 9.5-11.699z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path535",
    style: {
      fill: "navy",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m510.794 576.423-2.737 14.846-14.45-5.045 4.203-15.291z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path537",
    style: {
      fill: "#16ffe1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m447.43 429.87-18.096 14.046-3.68-25.563 18.619-13.594z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path539",
    style: {
      fill: "#0ff8e7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m736.42 437.403-36.887-6.564 1.526-16.924 37.44 7.97z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path541",
    style: {
      fill: "#0058ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m619.948 486.43-19.427 6.113-1.718 11.407 20.913-6.609z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path543",
    style: {
      fill: "#0048ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "M600.521 492.543 585.21 500.4l-3.33 11.915 16.924-8.365z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path545",
    style: {
      fill: "#0058ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m668.845 489.555-25.294 2.998 1.262 7.727 26.556-3.253z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path547",
    style: {
      fill: "#0068ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m442.277 492.095-10.512 16.408-8.19-23.448 11.35-16.36z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path549",
    style: {
      fill: "#0060ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m746.682 496.22-28.005-1.966 4.246-7.6 28.88 2.935z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path551",
    style: {
      fill: "#0054ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m741.377 500.683-27.096-1.163 4.396-5.266 28.005 1.966z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path553",
    style: {
      fill: "#0074ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m751.804 489.589-28.881-2.935 3.992-9.745 29.7 4.043z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path555",
    style: {
      fill: "#006cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m642.472 482.129-22.524 4.3-.232 10.912 23.835-4.788z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path557",
    style: {
      fill: "#0038ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m585.209 500.4-10.662 9.434-5 12.437 12.332-9.956z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path559",
    style: {
      fill: "#0054ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m697.379 495.462-26.01 1.565 2.801 4.833 27.117-1.584z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path561",
    style: {
      fill: "#c1ff36",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m661.215 351.478-43.038-7.662.153-18.811 42.708 8.812z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path563",
    style: {
      fill: "#000084",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m523.703 577.946-1.283 14.353-14.363-1.03 2.737-14.846z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path565",
    style: {
      fill: "#97ff60",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m468.01 369.545-25.162 10.007.362-24.679 25.1-9.275z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path567",
    style: {
      fill: "#004cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m736.02 502.864-26.175-.544 4.436-2.8 27.096 1.163z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path569",
    style: {
      fill: "#d1ff26",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m499.352 339.837-31.041 5.76 1.757-22.78 30.622-4.902z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path571",
    style: {
      fill: "#0090ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m756.615 480.952-29.7-4.043 3.639-11.653 30.442 5.265z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path573",
    style: {
      fill: "#36ffc1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m738.498 421.885-37.44-7.97 1.063-17.474 37.806 9.366z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path575",
    style: {
      fill: "#8dff6a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m702.69 378.853-41.564-8.84.089-18.535 41.533 10.116z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path577",
    style: {
      fill: "#ffea00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m576.19 319.179-39.73-2.447 1.629-19.307 38.978 3.4z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path579",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m561.92 533.549-3.297 12.232-9.294 9.885 5.046-12.704z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path581",
    style: {
      fill: "#0050ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m730.743 502.705-25.266-.128 4.368-.257 26.174.544z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path583",
    style: {
      fill: "#0000c4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m549.329 555.666-1.284 13.255-11.821 6.516 2.952-13.726z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path585",
    style: {
      fill: "#00b0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m760.996 470.521-30.442-5.265 3.195-13.276 31.088 6.571z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path587",
    style: {
      fill: "#fbf100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m618.33 325.005-42.14-5.826.877-18.353 41.444 6.825z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path589",
    style: {
      fill: "#0080ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m666.667 479.615-24.195 2.514 1.08 10.424 25.293-2.998z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path591",
    style: {
      fill: "#ffe200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m536.46 316.732-35.77 1.183 2.41-20.202 34.989-.288z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path593",
    style: {
      fill: "#53ffa4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m444.273 404.76-18.62 13.593-1.659-25.724 18.854-13.077z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path595",
    style: {
      fill: "#00b0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m434.925 468.695-11.35 16.36-6.227-24.92 11.986-16.219z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path597",
    style: {
      fill: "#002cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m574.547 509.834-5.979 10.74-6.649 12.975 7.629-11.278z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path599",
    style: {
      fill: "#0070ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m693.854 488.242-25.009 1.313 2.524 7.472 26.01-1.565z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path601",
    style: {
      fill: "#00009f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m479.416 577.305-1.203 15.18-14.16-12.36 1.77-15.39z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path603",
    style: {
      fill: "#0000c8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m465.823 564.735-1.77 15.39-13.202-15.746 2.301-15.563z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path605",
    style: {
      fill: "#008cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m620.167 472.853-18.192 5.423-1.454 14.267 19.427-6.113z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path607",
    style: {
      fill: "#005cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m725.68 500.204-24.393.072 4.19 2.301 25.266.128z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path609",
    style: {
      fill: "#007cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m601.975 478.276-13.97 7.18-2.796 14.944 15.312-7.857z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path611",
    style: {
      fill: "#00d8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m764.837 458.551-31.088-6.571 2.672-14.577 31.619 7.933z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path613",
    style: {
      fill: "#000089",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m493.606 586.224-.612 14.94-14.781-8.678 1.203-15.181z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path615",
    style: {
      fill: "#00009b",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m536.224 575.437.124 13.825-13.928 3.037 1.283-14.353z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path617",
    style: {
      fill: "#63ff94",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m739.927 405.807-37.806-9.366.57-17.588 37.975 10.721z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path619",
    style: {
      fill: "#0000fa",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m453.152 548.816-2.3 15.563-11.926-18.761 2.78-15.694z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path621",
    style: {
      fill: "#009cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m641.605 469.25-21.438 3.603-.219 13.577 22.524-4.301z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path623",
    style: {
      fill: "#f1fc06",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m661.038 333.817-42.708-8.812.181-17.354 42.088 9.841z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path625",
    style: {
      fill: "#beff39",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m702.748 361.594-41.533-10.116-.177-17.66 41.25 11.29z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path627",
    style: {
      fill: "#0070ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m588.005 485.456-9.266 8.771-4.192 15.607 10.662-9.434z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path629",
    style: {
      fill: "navy",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m508.057 591.269-.014 14.675-15.05-4.78.613-14.94z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path631",
    style: {
      fill: "#006cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m720.956 495.414-23.577.048 3.908 4.814 24.392-.072z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path633",
    style: {
      fill: "#d4ff23",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m468.31 345.598-25.1 9.275 2.16-23.521 24.698-8.536z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path635",
    style: {
      fill: "#19ffde",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m768.04 445.336-31.62-7.933 2.078-15.518 32.023 9.315z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path637",
    style: {
      fill: "#ffdb00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m500.69 317.915-30.622 4.901 3.188-21.021 29.844-4.082z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path639",
    style: {
      fill: "#0024ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m441.707 529.924-2.781 15.694-10.36-21.337 3.2-15.778z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path641",
    style: {
      fill: "#0094ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m690.804 478.781-24.137.834 2.178 9.94 25.01-1.313z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path643",
    style: {
      fill: "#00acff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m664.89 467.44-23.285 1.81.867 12.879 24.195-2.514z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path645",
    style: {
      fill: "#ffb200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m577.067 300.826-38.978-3.401 2.305-17.137 37.889 4.24z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path647",
    style: {
      fill: "#13fce4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m429.334 443.916-11.986 16.22-4.095-25.793 12.4-15.99z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path649",
    style: {
      fill: "#0000f1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m558.623 545.781.244 12.737-10.822 10.403 1.284-13.255z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path651",
    style: {
      fill: "#ffbd00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m618.511 307.651-41.444-6.825 1.216-16.297 40.433 7.69z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path653",
    style: {
      fill: "#0020ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m568.568 520.575-1.753 11.684-8.192 13.522 3.296-12.232z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path655",
    style: {
      fill: "#8dff6a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m740.666 389.574-37.976-10.721.058-17.26 37.945 12.003z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path657",
    style: {
      fill: "#006cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m763.01 503.058-21.633-2.375 5.305-4.463 22.236 3.136z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path659",
    style: {
      fill: "#0078ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m768.918 499.356-22.236-3.136 5.122-6.631 22.816 4.055z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path661",
    style: {
      fill: "#97ff60",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m442.848 379.552-18.854 13.077.426-25.246 18.79-12.51z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path663",
    style: {
      fill: "#0068ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m757.041 504.657-21.022-1.793 5.358-2.181 21.632 2.375z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path665",
    style: {
      fill: "#008cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m774.62 493.644-22.816-4.055 4.811-8.637 23.359 5.111z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path667",
    style: {
      fill: "#ffa700",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m538.089 297.425-34.989.288 3.434-17.94 33.86.515z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path669",
    style: {
      fill: "#00c4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m620.368 456.935-17.243 4.553-1.15 16.788 18.192-5.423z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path671",
    style: {
      fill: "#000084",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m522.42 592.299.579 14.394-14.956-.749.014-14.675z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path673",
    style: {
      fill: "#00b",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m548.045 568.92 1.452 13.28-13.149 7.062-.124-13.825z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path675",
    style: {
      fill: "#0084ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m716.693 488.444-22.839-.202 3.525 7.22 23.577-.048z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path677",
    style: {
      fill: "#0068ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m578.739 494.227-4.598 10.1-5.573 16.248 5.98-10.741z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path679",
    style: {
      fill: "#3cffba",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m770.52 431.2-32.022-9.315 1.429-16.078 32.287 10.69z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path681",
    style: {
      fill: "#00d0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m640.975 454.227-20.607 2.708-.2 15.918 21.437-3.602z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path683",
    style: {
      fill: "#0064ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m431.765 508.503-3.199 15.778-8.533-23.412 3.542-15.814z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path685",
    style: {
      fill: "#0068ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m751.162 504.112-20.419-1.407 5.276.159 21.022 1.793z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path687",
    style: {
      fill: "#00b8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m603.125 461.488-12.935 6.345-2.185 17.623 13.97-7.18z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path689",
    style: {
      fill: "#00a4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m779.974 486.063-23.359-5.11 4.381-10.432 23.848 6.277z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path691",
    style: {
      fill: "#ebff0c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m702.289 345.108-41.25-11.29-.44-16.326 40.721 12.334z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path693",
    style: {
      fill: "#ffc800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m660.6 317.492-42.089-9.841.205-15.433 41.19 10.72z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path695",
    style: {
      fill: "#00bcff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m688.309 467.306-23.418.133 1.776 12.176 24.137-.834z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path697",
    style: {
      fill: "#0074ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m745.52 501.43-19.84-1.226 5.063 2.501 20.42 1.407z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path699",
    style: {
      fill: "#00c4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m784.844 476.798-23.848-6.277 3.841-11.97 24.272 7.526z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path701",
    style: {
      fill: "#00dcfe",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m663.566 453.322-22.591.905.63 15.024 23.286-1.812z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path703",
    style: {
      fill: "#00b0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m590.19 467.833-8.187 7.982-3.264 18.412 9.266-8.771z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path705",
    style: {
      fill: "#b7ff40",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m740.693 373.596-37.945-12.002-.46-16.486 37.713 13.178z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path707",
    style: {
      fill: "#00a4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m713.001 479.457-22.197-.676 3.05 9.46 22.839.203z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path709",
    style: {
      fill: "#63ff94",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m772.214 416.497-32.287-10.69.74-16.233 32.405 12.022z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path711",
    style: {
      fill: "#000096",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m536.348 589.262 1.153 14.107-14.502 3.324-.579-14.394z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path713",
    style: {
      fill: "#53ffa4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m425.654 418.353-12.401 15.99-1.84-26.038 12.581-15.676z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path715",
    style: {
      fill: "gold",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m470.068 322.816-24.698 8.536 3.925-21.75 23.96-7.807z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path717",
    style: {
      fill: "#ff7a00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m578.283 284.529-37.89-4.24 2.93-14.492 36.485 4.94z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path719",
    style: {
      fill: "#ff9c00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m503.1 297.713-29.844 4.082 4.554-18.697 28.724-3.325z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path721",
    style: {
      fill: "#ff8900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m618.716 292.218-40.433-7.69 1.525-13.792 39.133 8.394z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path723",
    style: {
      fill: "#0084ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m740.256 496.674-19.3-1.26 4.723 4.79 19.841 1.227z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path725",
    style: {
      fill: "#00009f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m478.213 592.486 1.719 13.863-14.133-12.339-1.746-13.885z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path727",
    style: {
      fill: "#00e4f8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m789.109 466.077-24.272-7.526 3.203-13.215 24.618 8.828z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path729",
    style: {
      fill: "#0000c8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m464.053 580.125 1.746 13.885-13.175-15.708-1.773-13.923z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path731",
    style: {
      fill: "#0018ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m566.815 532.259 1.593 12.186-9.54 14.073-.245-12.737z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path733",
    style: {
      fill: "#00acff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m423.575 485.055-3.542 15.814-6.488-24.931 3.803-15.802z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path735",
    style: {
      fill: "#000089",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m492.994 601.164 1.691 13.858-14.753-8.673-1.719-13.863z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path737",
    style: {
      fill: "#005cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m574.14 504.326-.457 11.073-6.868 16.86 1.753-11.684z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path739",
    style: {
      fill: "#16ffe1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m620.544 439.065-16.609 3.523-.81 18.9 17.243-4.553z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path741",
    style: {
      fill: "#0000ed",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m558.867 558.518 2.668 12.73-12.038 10.952-1.452-13.28z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path743",
    style: {
      fill: "gold",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m701.32 329.826-40.72-12.334-.694-14.554 39.956 13.216z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path745",
    style: {
      fill: "#1cffdb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m640.6 437.426-20.056 1.639-.176 17.87 20.607-2.708z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path747",
    style: {
      fill: "#d7ff1f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m443.21 354.873-18.79 12.51 2.525-24.124 18.425-11.907z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path749",
    style: {
      fill: "#0000fa",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m450.851 564.379 1.773 13.923-11.901-18.708-1.797-13.976z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path751",
    style: {
      fill: "#02e8f4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m686.437 454.095-22.87-.773 1.323 14.117 23.419-.133z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path753",
    style: {
      fill: "#ff6f00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m540.394 280.288-33.86-.515 4.38-15.181 32.408 1.204z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path755",
    style: {
      fill: "#ff9800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m659.906 302.938-41.19-10.72.225-13.088 40.033 11.423z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path757",
    style: {
      fill: "#13fce4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m603.935 442.588-12.237 5.371-1.508 19.874 12.935-6.345z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path759",
    style: {
      fill: "#009cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m735.505 489.954-18.812-1.51 4.263 6.97 19.3 1.26z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path761",
    style: {
      fill: "#00a8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m582.003 475.815-3.524 9.366-4.338 19.145 4.598-10.099z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path763",
    style: {
      fill: "#0cf",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m709.977 468.672-21.668-1.366 2.495 11.475 22.197.676z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path765",
    style: {
      fill: "#1fffd7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m792.658 454.164-24.618-8.828 2.48-14.136 24.88 10.153z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path767",
    style: {
      fill: "navy",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m508.043 605.944 1.664 13.869-15.022-4.791-1.691-13.858z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path769",
    style: {
      fill: "#8dff6a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m773.072 401.596-32.406-12.022.027-15.978 32.373 13.28z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path771",
    style: {
      fill: "#e1ff16",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m740 358.286-37.711-13.178-.969-15.282 37.282 14.216z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path773",
    style: {
      fill: "#23ffd4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m662.732 437.612-22.133-.186.376 16.8 22.591-.904z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path775",
    style: {
      fill: "#0024ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m438.926 545.618 1.797 13.976-10.336-21.27-1.82-14.043z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path777",
    style: {
      fill: "#0084ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m777.68 506.395-14.67-3.337 5.908-3.702 15 4.033z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path779",
    style: {
      fill: "#00b",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m549.497 582.2 1.692 13.818-13.688 7.35-1.153-14.106z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path781",
    style: {
      fill: "#0080ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m771.38 507.467-14.339-2.81 5.968-1.6 14.672 3.338z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path783",
    style: {
      fill: "#0090ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m783.918 503.39-15-4.034 5.702-5.712 15.315 4.879z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path785",
    style: {
      fill: "#0084ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m765.172 506.575-14.01-2.463 5.88.545 14.338 2.81z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path787",
    style: {
      fill: "#00a0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m789.935 498.523-15.315-4.879 5.354-7.58 15.607 5.85z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path789",
    style: {
      fill: "#0cf4eb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m591.698 447.96-7.454 7.083-2.24 20.772 8.186-7.982z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path791",
    style: {
      fill: "#13fce4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m417.348 460.136-3.803 15.802-4.263-25.854 3.97-15.741z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path793",
    style: {
      fill: "#00b8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m731.388 481.431-18.387-1.974 3.692 8.987 18.812 1.51z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path795",
    style: {
      fill: "#ff6000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m618.94 279.13-39.132-8.394 1.798-10.895 37.572 8.914z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path797",
    style: {
      fill: "#43ffb4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "M795.4 441.353 770.52 431.2l1.694-14.703 25.044 11.468z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path799",
    style: {
      fill: "#97ff60",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m423.994 392.63-12.58 15.675.487-25.632 12.519-15.29z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path801",
    style: {
      fill: "#000084",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m522.999 606.693 1.64 13.896-14.932-.776-1.664-13.869z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path803",
    style: {
      fill: "#ff4e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m579.808 270.736-36.486-4.94 3.482-11.433 34.802 5.478z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path805",
    style: {
      fill: "#ffab00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m699.862 316.154-39.956-13.216-.932-12.385 38.975 13.913z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path807",
    style: {
      fill: "#008cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m759.214 503.74-13.694-2.31 5.642 2.682 14.01 2.463z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path809",
    style: {
      fill: "#2cffca",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m685.243 439.475-22.51-1.863.833 15.71 22.871.773z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path811",
    style: {
      fill: "#00b8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m795.58 491.915-15.606-5.852 4.87-9.265 15.87 6.93z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path813",
    style: {
      fill: "#ff9400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m473.256 301.795-23.96 7.807 5.613-19.393 22.9-7.11z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path815",
    style: {
      fill: "#ff6400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m506.534 279.773-28.724 3.325 5.819-15.853 27.285-2.653z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path817",
    style: {
      fill: "#0cf4eb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m707.704 456.35-21.267-2.255 1.872 13.211 21.668 1.366z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path819",
    style: {
      fill: "#50ffa7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m640.49 419.274-19.799.42-.147 19.37 20.055-1.638z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path821",
    style: {
      fill: "#4dffaa",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m620.691 419.694-16.309 2.358-.447 20.536 16.609-3.523z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path823",
    style: {
      fill: "#b4ff43",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m773.066 386.875-32.373-13.279-.692-15.31 32.19 14.43z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path825",
    style: {
      fill: "#0058ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m573.683 515.399 2.726 11.614-8.001 17.432-1.593-12.186z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path827",
    style: {
      fill: "#ff6f00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "M658.974 290.553 618.94 279.13l.237-10.375 38.648 11.929z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path829",
    style: {
      fill: "#0068ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m428.566 524.28 1.821 14.045-8.513-23.332-1.841-14.124z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path831",
    style: {
      fill: "#ffe200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m738.602 344.042-37.282-14.216-1.458-13.672 36.665 15.092z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path833",
    style: {
      fill: "#0014ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m568.408 544.445 3.74 12.19-10.613 14.613-2.668-12.73z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path835",
    style: {
      fill: "#00a0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m578.48 485.181.551 10.41-5.348 19.808.458-11.073z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path837",
    style: {
      fill: "#009cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m753.655 499.029-13.399-2.355 5.264 4.757 13.694 2.31z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path839",
    style: {
      fill: "#53ffa4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m662.415 420.707-21.924-1.433.108 18.152 22.133.186z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path841",
    style: {
      fill: "#00d4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m800.714 483.728-15.87-6.93 4.265-10.72 16.093 8.086z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path843",
    style: {
      fill: "#ff3f00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m543.322 265.796-32.408-1.204 5.223-11.987 30.667 1.758z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path845",
    style: {
      fill: "#ffd300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m445.37 331.352-18.425 11.907 4.586-22.371 17.764-11.286z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path847",
    style: {
      fill: "#49ffad",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m604.382 422.052-11.901 4.285-.783 21.623 12.237-5.372z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path849",
    style: {
      fill: "#00dcfe",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m728.014 471.312-18.037-2.64 3.024 10.785 18.387 1.974z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path851",
    style: {
      fill: "#66ff90",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m797.258 427.965-25.044-11.468.858-14.901 25.111 12.744z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path853",
    style: {
      fill: "#09f0ee",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m584.244 455.043-2.79 8.56-2.975 21.578 3.524-9.366z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path855",
    style: {
      fill: "#00009b",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m537.5 603.369 1.616 13.939-14.478 3.281L523 606.693z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path857",
    style: {
      fill: "#0000e8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m561.535 571.248 2.186 13.538-12.532 11.232-1.692-13.818z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path859",
    style: {
      fill: "#00b0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m748.636 492.554-13.131-2.6 4.751 6.72 13.399 2.355z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path861",
    style: {
      fill: "#0cf4eb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m805.202 474.164-16.093-8.087 3.55-11.913 16.273 9.294z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path863",
    style: {
      fill: "#33ffc4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m706.245 442.8-21.002-3.325 1.194 14.62 21.267 2.255z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path865",
    style: {
      fill: "#56ffa0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m684.762 423.818-22.347-3.111.317 16.905 22.511 1.863z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path867",
    style: {
      fill: "#ff3b00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m619.178 268.755-37.572-8.914 2.026-7.677 35.791 9.235z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path869",
    style: {
      fill: "#0000a8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m479.932 606.349 2.654 12.44-13.986-12.21-2.801-12.569z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path871",
    style: {
      fill: "#d7ff1f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m772.191 372.717-32.19-14.431-1.4-14.244 31.863 15.448z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path873",
    style: {
      fill: "#ff8600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m697.949 304.466-38.975-13.913-1.148-9.87 37.801 14.404z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path875",
    style: {
      fill: "#0000cd",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m465.799 594.01 2.801 12.568-13.036-15.537-2.94-12.74z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path877",
    style: {
      fill: "#53ffa4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m413.253 434.343-3.971 15.74-1.91-26.143 4.041-15.635z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path879",
    style: {
      fill: "#46ffb1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m592.481 426.337-7.092 6.098-1.145 22.608 7.454-7.084z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path881",
    style: {
      fill: "#ff2900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m581.606 259.841-34.802-5.478 3.948-8.034 32.88 5.835z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path883",
    style: {
      fill: "#00b0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m420.033 500.87 1.841 14.123-6.469-24.841-1.86-14.214z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path885",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m640.655 400.24-19.85-.917-.114 20.371 19.8-.42z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path887",
    style: {
      fill: "#000092",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m494.685 615.022 2.503 12.36-14.602-8.592-2.654-12.441z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path889",
    style: {
      fill: "#ffb900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m736.527 331.246-36.665-15.092-1.913-11.688 35.876 15.777z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path891",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m620.806 399.323-16.356 1.089-.068 21.64 16.31-2.358z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path893",
    style: {
      fill: "#16ffe1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m725.474 459.846-17.77-3.496 2.273 12.322 18.037 2.64z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path895",
    style: {
      fill: "#ff4e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m657.826 280.684-38.648-11.929.245-7.356 37.068 12.217z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path897",
    style: {
      fill: "#8aff6d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m798.183 414.34-25.111-12.744-.006-14.72 25.078 13.948z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path899",
    style: {
      fill: "#d7ff1f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m424.42 367.383-12.519 15.29 2.83-24.572 12.214-14.842z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path901",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m452.624 578.302 2.94 12.739-11.773-18.497-3.068-12.95z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path903",
    style: {
      fill: "#00c8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m744.286 484.472-12.898-3.04 4.117 8.522 13.13 2.6z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path905",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m662.627 403.042-21.972-2.802-.164 19.034 21.924 1.433z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path907",
    style: {
      fill: "#29ffce",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m808.932 463.458-16.274-9.294 2.741-12.811 16.404 10.525z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path909",
    style: {
      fill: "#ff3000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m510.914 264.592-27.285 2.653 6.946-12.553 25.562-2.087z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path911",
    style: {
      fill: "#ff5900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m477.81 283.098-22.901 7.11 7.176-16.496 21.544-6.467z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path913",
    style: {
      fill: "#0098ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m777.929 511.093-6.55-3.626 6.302-1.072 6.65 4.092z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path915",
    style: {
      fill: "#009cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m784.332 510.487-6.651-4.092 6.237-3.006 6.75 4.708z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path917",
    style: {
      fill: "#000084",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m509.707 619.813 2.35 12.327-14.87-4.758-2.502-12.36z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path919",
    style: {
      fill: "#0098ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m771.62 509.901-6.448-3.326 6.208.892 6.549 3.626z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path921",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m604.45 400.412-11.94 3.111-.029 22.814 11.901-4.285z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path923",
    style: {
      fill: "#00a4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m790.668 508.097-6.75-4.708 6.017-4.866 6.844 5.46z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path925",
    style: {
      fill: "#009cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m579.031 495.59 3.614 11.036-6.236 20.387-2.726-11.614z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path927",
    style: {
      fill: "#00b",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m551.19 596.018 1.593 13.998-13.667 7.292-1.615-13.94z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path929",
    style: {
      fill: "#0054ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m576.41 527.013 4.64 11.674-8.902 17.948-3.74-12.19z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path931",
    style: {
      fill: "#ff1600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m546.804 254.363-30.667-1.758 5.936-8.434 28.679 2.158z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path933",
    style: {
      fill: "#5aff9d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m705.643 428.365-20.88-4.547.48 15.657 21.002 3.325z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path935",
    style: {
      fill: "#00a0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m765.562 506.939-6.348-3.199 5.958 2.835 6.447 3.326z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path937",
    style: {
      fill: "#0028ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m440.723 559.594 3.068 12.95-10.222-21.023-3.182-13.196z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path939",
    style: {
      fill: "#06ecf1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m581.454 463.603 1.247 9.711-3.67 22.277-.552-10.41z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path941",
    style: {
      fill: "#fbf100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m770.464 359.49-31.862-15.448-2.075-12.796 31.397 16.3z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path943",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m685.013 407.527-22.386-4.485-.212 17.665 22.347 3.111z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path945",
    style: {
      fill: "#00b4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m796.779 503.983-6.844-5.46 5.646-6.608 6.928 6.329z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path947",
    style: {
      fill: "#02e8f4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m740.72 474.98-12.706-3.668 3.374 10.12 12.898 3.04z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path949",
    style: {
      fill: "#ff6400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m695.627 295.087-37.801-14.403-1.335-7.068 36.465 14.668z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path951",
    style: {
      fill: "#ff9100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m449.295 309.602-17.764 11.286 6.557-20.015 16.82-10.664z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path953",
    style: {
      fill: "#46ffb1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "M811.803 451.878 795.4 441.353l1.86-13.388 16.481 11.749z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path955",
    style: {
      fill: "#39ffbe",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m723.837 447.32-17.592-4.52 1.459 13.55 17.77 3.496z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path957",
    style: {
      fill: "#f20",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m619.423 261.399-35.79-9.235 2.2-4.22 33.835 9.341z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path959",
    style: {
      fill: "#adff49",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m798.144 400.824-25.078-13.949-.875-14.158 24.945 15.05z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path961",
    style: {
      fill: "#43ffb4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m585.389 432.435-2.42 7.698-1.515 23.47 2.79-8.56z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path963",
    style: {
      fill: "#00b0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m759.91 502.278-6.255-3.249 5.56 4.711 6.347 3.199z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path965",
    style: {
      fill: "#ff9800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m733.825 320.243-35.876-15.777-2.322-9.38 34.936 16.253z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path967",
    style: {
      fill: "#0014ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m572.148 556.635 2.622 13.275-11.05 14.876-2.185-13.538z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path969",
    style: {
      fill: "#b4ff43",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m641.09 380.823-20.207-2.332-.077 20.832 19.85.917z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path971",
    style: {
      fill: "#00c8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m802.51 498.244-6.93-6.33 5.134-8.186 7 7.293z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path973",
    style: {
      fill: "#00008d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m524.638 620.59 2.198 12.344-14.78-.794-2.349-12.327z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path975",
    style: {
      fill: "#ff3800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m656.49 273.616-37.067-12.217.245-4.114 35.334 12.278z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path977",
    style: {
      fill: "#13fce4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m413.545 475.938 1.86 14.214-4.249-25.754-1.874-14.314z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path979",
    style: {
      fill: "#adff49",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m663.366 385.083-22.276-4.26-.435 19.417 21.972 2.802z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path981",
    style: {
      fill: "#b7ff40",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m620.883 378.491-16.751-.251.318 22.172 16.356-1.089z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path983",
    style: {
      fill: "#f60b00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m583.632 252.164-32.88-5.835 4.314-4.383 30.768 5.999z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path985",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m592.51 403.523-7.116 5.05-.005 23.862 7.092-6.098z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path987",
    style: {
      fill: "#97ff60",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m411.413 408.305-4.042 15.635.517-25.78 4.013-15.487z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path989",
    style: {
      fill: "#00c0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m754.805 496.031-6.17-3.477 5.02 6.475 6.254 3.249z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path991",
    style: {
      fill: "#0068ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m430.387 538.325 3.182 13.196-8.415-23.055-3.28-13.473z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path993",
    style: {
      fill: "#1fffd7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m738.03 464.316-12.556-4.47 2.54 11.466 12.705 3.668z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path995",
    style: {
      fill: "#00e0fb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m807.715 491.021-7.001-7.293 4.488-9.564 7.06 8.329z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path997",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m705.922 413.416-20.909-5.89-.25 16.292 20.88 4.547z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path999",
    style: {
      fill: "#66ff90",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m813.74 439.714-16.482-11.749.925-13.625 16.504 12.935z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1001",
    style: {
      fill: "#fc0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m767.924 347.547-31.397-16.301-2.702-11.003 30.807 16.968z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1003",
    style: {
      fill: "#aaff4d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m685.995 391.027-22.629-5.944-.74 17.96 22.387 4.484z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1005",
    style: {
      fill: "#baff3c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m604.132 378.24-12.354 1.885.733 23.398 11.939-3.111z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1007",
    style: {
      fill: "#5aff9d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m723.153 434.053-17.51-5.688.602 14.435 17.592 4.52z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1009",
    style: {
      fill: "#ff4e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m692.956 288.284-36.465-14.668-1.49-4.053 35.002 14.697z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1011",
    style: {
      fill: "#ffd000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "M426.945 343.259 414.732 358.1l5.131-22.867 11.668-14.346z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1013",
    style: {
      fill: "#d1ff26",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m797.136 387.768-24.945-15.051-1.727-13.227 24.716 16.023z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1015",
    style: {
      fill: "#f10800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m516.137 252.605-25.562 2.087 7.902-8.877 23.596-1.644z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1017",
    style: {
      fill: "#00d8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m750.38 488.353-6.094-3.881 4.35 8.082 6.169 3.477z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1019",
    style: {
      fill: "#0000ed",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m563.72 584.786 1.576 14.07-12.513 11.16-1.594-13.998z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1021",
    style: {
      fill: "#ff7a00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m730.563 311.339-34.936-16.252-2.671-6.803 33.869 16.5z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1023",
    style: {
      fill: "#df0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m550.752 246.329-28.679-2.158 6.497-4.614 26.496 2.39z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1025",
    style: {
      fill: "#e4ff13",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m641.786 361.546-20.864-3.789-.039 20.734 20.207 2.332z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1027",
    style: {
      fill: "#fa0f00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m619.668 257.285-33.834-9.34 2.319-.616 31.755 9.224z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1029",
    style: {
      fill: "#ff2500",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m483.629 267.245-21.544 6.467 8.569-13.126 19.921-5.894z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1031",
    style: {
      fill: "#16ffe1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m812.262 482.493-7.06-8.33 3.73-10.705 7.101 9.412z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1033",
    style: {
      fill: "#00009f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m539.116 617.308 2.051 12.412-14.331 3.214-2.198-12.345z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1035",
    style: {
      fill: "#ff2500",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m655.002 269.563-35.334-12.278.24-.732 33.491 12.104z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1037",
    style: {
      fill: "#dbff1c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m664.618 367.308-22.832-5.762-.696 19.277 22.276 4.26z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1039",
    style: {
      fill: "#ebff0c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m620.922 357.757-17.488-1.622.698 22.105 16.751.251z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1041",
    style: {
      fill: "#02e8f4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m582.701 473.314 4.23 10.463-4.286 22.85-3.614-11.036z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1043",
    style: {
      fill: "#3cffba",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m736.292 452.744-12.455-5.423 1.637 12.525 12.556 4.47z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1045",
    style: {
      fill: "#0098ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m582.645 506.626 5.35 11.195-6.944 20.866-4.642-11.674z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1047",
    style: {
      fill: "#43ffb4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m582.969 440.133 1.605 8.993-1.873 24.188-1.247-9.71z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1049",
    style: {
      fill: "#df0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m585.834 247.945-30.768-5.999 4.565-.576 28.522 5.959z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1051",
    style: {
      fill: "#0000b2",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m482.586 618.79 2.6 10.423-13.72-11.979-2.866-10.656z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1053",
    style: {
      fill: "#8aff6d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m814.687 427.275-16.504-12.935-.039-13.516 16.471 14.056Z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1055",
    style: {
      fill: "#0000da",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m468.6 606.578 2.867 10.656L458.68 602l-3.117-10.96z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1057",
    style: {
      fill: "#a7ff50",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m707.078 398.343-21.083-7.316-.982 16.5 20.909 5.889z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1059",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m585.394 408.574-2.43 6.803.005 24.756 2.42-7.698z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1061",
    style: {
      fill: "#0cf4eb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m746.747 479.431-6.028-4.45 3.567 9.49 6.093 3.882z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1063",
    style: {
      fill: "#00a8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m776.122 515.395 1.807-4.302 6.403-.606-1.879 4.701z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1065",
    style: {
      fill: "#ffab00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m764.632 337.21-30.807-16.967-3.262-8.904 30.106 17.426z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1067",
    style: {
      fill: "#00b0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m421.874 514.993 3.28 13.473-6.392-24.54-3.357-13.774z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1069",
    style: {
      fill: "#d4ff23",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m687.686 374.758-23.068-7.45-1.252 17.775 22.63 5.944z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1071",
    style: {
      fill: "#00acff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m769.882 513.944 1.737-4.043 6.31 1.192-1.807 4.302z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1073",
    style: {
      fill: "#f50",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m454.909 290.209-16.821 10.664 8.38-17.1 15.617-10.061z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1075",
    style: {
      fill: "#53ffa4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m409.282 450.084 1.874 14.314-1.9-26.038-1.885-14.42z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1077",
    style: {
      fill: "#00009b",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m497.188 627.382 2.321 10.267-14.324-8.436-2.599-10.423z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1079",
    style: {
      fill: "#ff3f00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m690.003 284.26-35.001-14.697-1.603-.906 33.449 14.483z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1081",
    style: {
      fill: "#00acff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m782.453 515.188 1.879-4.701 6.336-2.39-1.952 5.232z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1083",
    style: {
      fill: "#beff39",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m591.778 380.125-7.531 3.969 1.147 24.48 7.117-5.05z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1085",
    style: {
      fill: "#0050ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m581.05 538.687 2.99 13.034-9.27 18.189-2.622-13.275z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1087",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m723.444 420.383-17.522-6.967-.279 14.95 17.51 5.687z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1089",
    style: {
      fill: "#30ffc7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m816.033 472.87-7.101-9.412 2.871-11.58 7.126 10.516z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1091",
    style: {
      fill: "#f1fc06",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m795.18 375.513-24.716-16.023-2.54-11.943 24.396 16.84z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1093",
    style: {
      fill: "#00b4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m763.89 510.872 1.672-3.933 6.057 2.962-1.737 4.043z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1095",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m455.564 591.04 3.117 10.96-11.543-18.13-3.347-11.326z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1097",
    style: {
      fill: "#ff6400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m726.825 304.785-33.87-16.5-2.952-4.025 32.703 16.51z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1099",
    style: {
      fill: "#00b8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m788.716 513.329 1.952-5.232 6.11-4.114-2.026 5.879z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1101",
    style: {
      fill: "gold",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m642.726 342.932-21.806-5.244.002 20.07 20.865 3.788z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1103",
    style: {
      fill: "#f1fc06",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m603.434 356.135-13.139.639 1.483 23.35 12.354-1.884z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1105",
    style: {
      fill: "#ed0400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m619.908 256.553-31.755-9.224 2.374 3.033 29.607 8.885z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1107",
    style: {
      fill: "#ff1e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m653.4 268.657-33.492-12.104.226 2.694 31.591 11.694z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1109",
    style: {
      fill: "#ffe200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m666.35 350.197-23.624-7.265-.94 18.614 22.832 5.762z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1111",
    style: {
      fill: "#00c0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m758.295 506.255 1.614-3.977 5.653 4.66-1.673 3.934z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1113",
    style: {
      fill: "#d7ff1f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m411.901 382.673-4.013 15.487 2.962-24.757 3.882-15.302z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1115",
    style: {
      fill: "#000092",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m512.056 632.14 2.04 10.191-14.587-4.682-2.321-10.267z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1117",
    style: {
      fill: "#fc0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m620.92 337.688-18.547-2.984 1.061 21.431 17.488 1.622z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1119",
    style: {
      fill: "#00c4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m794.752 509.862 2.027-5.88 5.73-5.738-2.1 6.627z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1121",
    style: {
      fill: "#5dff9a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m735.556 440.56-12.403-6.507.684 13.268 12.455 5.423z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1123",
    style: {
      fill: "#26ffd1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m744.005 469.489-5.975-5.173 2.69 10.665 6.027 4.45z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1125",
    style: {
      fill: "#aaff4d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m814.615 414.88-16.47-14.056-1.009-13.056 16.383 15.082z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1127",
    style: {
      fill: "#c80000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m555.066 241.946-26.496-2.389 6.886-.628 24.175 2.441z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1129",
    style: {
      fill: "#0000c4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m552.783 610.016 1.914 12.528-13.53 7.176-2.051-12.412z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1131",
    style: {
      fill: "#00d0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m753.242 500.206 1.563-4.175 5.104 6.247-1.614 3.977z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1133",
    style: {
      fill: "#cd0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m522.073 244.17-23.596 1.645 8.654-4.918 21.44-1.34z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1135",
    style: {
      fill: "#ceff29",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m709.088 383.545-21.402-8.787-1.69 16.27 21.082 7.315z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1137",
    style: {
      fill: "#ff3800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m686.848 283.14-33.449-14.483-1.674 2.284 31.849 14.03z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1139",
    style: {
      fill: "#fbf100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m690.046 359.157-23.695-8.96-1.733 17.11 23.068 7.451z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1141",
    style: {
      fill: "#4dffaa",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m818.929 462.394-7.126-10.516 1.937-12.164 7.13 11.615z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1143",
    style: {
      fill: "#0030ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m443.791 572.544 3.347 11.326-10.02-20.6-3.549-11.75z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1145",
    style: {
      fill: "#d10000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m588.153 247.329-28.522-5.959 4.693 3.278 26.203 5.714z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1147",
    style: {
      fill: "#ff9100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m760.669 328.765-30.106-17.426-3.738-6.554 29.312 17.662z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1149",
    style: {
      fill: "#0014ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m574.77 569.91 1.56 14.155-11.034 14.791-1.575-14.07z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1151",
    style: {
      fill: "#ffa700",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m643.886 325.492-23.008-6.654.042 18.85 21.806 5.244z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1153",
    style: {
      fill: "#00d8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m800.41 504.871 2.1-6.627 5.205-7.223-2.17 7.458z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1155",
    style: {
      fill: "#a4ff53",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m724.71 406.668-17.632-8.325-1.156 15.073 17.522 6.967z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1157",
    style: {
      fill: "#f50",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m722.706 300.77-32.703-16.51-3.155-1.12 31.467 16.278z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1159",
    style: {
      fill: "#ffdb00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m792.32 364.387-24.396-16.84-3.292-10.336 23.994 17.477z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161",
    style: {
      fill: "#ff1e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m651.725 270.94-31.59-11.693.207 6.064 29.684 11.058z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1163",
    style: {
      fill: "#ff8d00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m431.531 320.888-11.668 14.346 7.33-20.545 10.895-13.816z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1165",
    style: {
      fill: "#ffb600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m668.52 334.218-24.634-8.726-1.16 17.44 23.625 7.265z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1167",
    style: {
      fill: "#f10800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m620.134 259.247-29.607-8.885 2.364 6.62 27.45 8.329z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1169",
    style: {
      fill: "#e40000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m490.575 254.692-19.921 5.894 9.75-9.361 18.073-5.41z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1171",
    style: {
      fill: "#02e8f4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m748.858 492.874 1.521-4.521 4.426 7.678-1.563 4.175z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1173",
    style: {
      fill: "#ffc100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m602.373 334.704-14.274-.59 2.196 22.66 13.14-.639z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1175",
    style: {
      fill: "#ff9800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m620.878 318.838-19.903-4.298 1.398 20.164 18.547 2.984z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1177",
    style: {
      fill: "#000096",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m526.836 632.934 1.76 10.196-14.5-.799-2.04-10.19z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1179",
    style: {
      fill: "#f8f500",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m590.295 356.774-8.328 2.884 2.28 24.436 7.53-3.97z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1181",
    style: {
      fill: "#43ffb4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m742.227 458.776-5.935-6.032 1.738 11.572 5.975 5.173z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1183",
    style: {
      fill: "#13fce4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m415.405 490.152 3.357 13.774-4.192-25.435-3.414-14.093z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1185",
    style: {
      fill: "#ff3800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m683.574 284.971-31.849-14.03-1.7 5.428 30.245 13.346z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1187",
    style: {
      fill: "#c1ff36",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m584.247 384.094-2.822 5.897 1.54 25.386 2.429-6.803z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1189",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m735.846 428.075-12.402-7.692-.291 13.67 12.403 6.507z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1191",
    style: {
      fill: "#ff7e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m645.234 309.708-24.437-7.976.081 17.106 23.008 6.654z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1193",
    style: {
      fill: "#09f0ee",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m805.545 498.48 2.17-7.459 4.547-8.528-2.238 8.35z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1195",
    style: {
      fill: "#83ff73",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m582.965 415.377 1.611 8.274-.002 25.475-1.605-8.993z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1197",
    style: {
      fill: "#ffc400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m693.013 344.648-24.492-10.43-2.17 15.979 23.695 8.96z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1199",
    style: {
      fill: "#ff2900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m650.026 276.37-29.684-11.059.183 9.283 27.822 10.21z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1201",
    style: {
      fill: "#40ffb7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m584.574 449.126 4.552 9.909-2.196 24.742-4.229-10.463z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1203",
    style: {
      fill: "#ff9100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m671.07 319.812-25.836-10.104-1.348 15.784 24.635 8.726z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1205",
    style: {
      fill: "#caff2c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m813.52 402.85-16.384-15.082-1.956-12.255 16.243 15.988z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1207",
    style: {
      fill: "#6aff8d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m820.87 451.329-7.13-11.615.947-12.44 7.116 12.682z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1209",
    style: {
      fill: "#f1fc06",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m711.903 369.418-21.857-10.26-2.36 15.6 21.402 8.787z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1211",
    style: {
      fill: "#00e4f8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m586.93 483.777 5.843 10.763-4.778 23.28-5.35-11.194z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1213",
    style: {
      fill: "#ff7a00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m756.137 322.447-29.312-17.662-4.12-4.015 28.45 17.665z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1215",
    style: {
      fill: "#ff4e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m718.315 299.418-31.467-16.278-3.274 1.831 30.197 15.805z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1217",
    style: {
      fill: "#ff1300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m620.342 265.311-27.451-8.328 2.288 10.042 25.346 7.569z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1219",
    style: {
      fill: "#d60000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m590.527 250.362-26.203-5.714 4.692 7.069 23.875 5.266z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1221",
    style: {
      fill: "#ff5900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m646.735 296.02-26.057-9.174.119 14.886 24.437 7.976z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1223",
    style: {
      fill: "#97ff60",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m407.371 423.94 1.886 14.42.524-25.67-1.893-14.53z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1225",
    style: {
      fill: "#ff3b00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m648.347 284.804-27.822-10.21.153 12.252 26.057 9.174z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1227",
    style: {
      fill: "#0070ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m433.57 551.52 3.548 11.75-8.245-22.582-3.72-12.222z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1229",
    style: {
      fill: "#16ffe1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m745.257 484.442 1.49-5.01 3.632 8.92-1.52 4.522z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1231",
    style: {
      fill: "#ff4300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m680.27 289.715-30.244-13.346-1.68 8.435 28.68 12.446z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1233",
    style: {
      fill: "#ff6c00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m620.797 301.732-21.519-5.524 1.697 18.332 19.903 4.298z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1235",
    style: {
      fill: "#ff6f00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m673.932 307.374-27.197-11.354-1.501 13.688 25.837 10.104z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1237",
    style: {
      fill: "#c7ff30",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m726.923 393.268-17.835-9.723-2.01 14.798 17.632 8.325z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1239",
    style: {
      fill: "#ff1e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m462.085 273.712-15.617 10.06 10.004-13.695 14.182-9.491z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1241",
    style: {
      fill: "#b00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m559.63 241.37-24.174-2.44 7.09 3.409 21.778 2.31z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1243",
    style: {
      fill: "#ffbd00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m788.626 354.688-23.994-17.477-3.963-8.446 23.523 17.915z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1245",
    style: {
      fill: "#f50",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m677.026 297.25-28.68-12.446-1.611 11.216 27.197 11.354z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1247",
    style: {
      fill: "#0098ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m587.995 517.82 3.278 12.824-7.233 21.077-2.99-13.034z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1249",
    style: {
      fill: "#ff2900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m620.525 274.594-25.346-7.569 2.15 13.196 23.349 6.625z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1251",
    style: {
      fill: "#ff4700",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m620.678 286.846-23.35-6.625 1.95 15.987 21.519 5.524z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1253",
    style: {
      fill: "#ffa300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m696.512 331.628-25.441-11.816-2.55 14.406 24.492 10.43z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1255",
    style: {
      fill: "#ff8900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m600.975 314.54-15.732-1.765 2.856 21.338 14.274.59z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1257",
    style: {
      fill: "#1cffdb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m810.024 490.844 2.238-8.351 3.771-9.623-2.3 9.284z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1259",
    style: {
      fill: "#ff5200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m713.771 300.776-30.197-15.805-3.304 4.744 28.926 15.102z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1261",
    style: {
      fill: "#60ff97",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m741.464 447.563-5.908-7.003.736 12.184 5.935 6.032z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1263",
    style: {
      fill: "#00bcff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m759.95 518.619 9.932-4.675 6.24 1.45-10.115 4.9z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1265",
    style: {
      fill: "#b20000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m528.57 239.557-21.439 1.34 9.177-.783 19.148-1.185z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1267",
    style: {
      fill: "#00b8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m766.007 520.295 10.115-4.9 6.331-.207-10.304 5.24z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1269",
    style: {
      fill: "#0000f1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m565.296 598.856 1.788 12.69-12.387 10.998-1.914-12.528z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1271",
    style: {
      fill: "#00c4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m754.132 515.443 9.757-4.57 5.993 3.071-9.931 4.675z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1273",
    style: {
      fill: "gold",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m715.451 356.344-22.438-11.696-2.967 14.51 21.857 10.26z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1275",
    style: {
      fill: "#a0ff56",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m737.16 415.614-12.45-8.946-1.266 13.715 12.402 7.692z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1277",
    style: {
      fill: "#ff6f00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m751.155 318.435-28.45-17.665-4.39-1.352 27.54 17.43z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1279",
    style: {
      fill: "#e40000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m592.89 256.983-23.874-5.266 4.562 10.681 21.601 4.627z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1281",
    style: {
      fill: "#ff8200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m700.448 320.455-26.516-13.08-2.861 12.437 25.44 11.816z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1283",
    style: {
      fill: "#ffd000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m414.732 358.1-3.882 15.303 5.361-23.084 3.652-15.085z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1285",
    style: {
      fill: "#0000a8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m541.167 629.72 1.489 10.284-14.06 3.126-1.76-10.196z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1287",
    style: {
      fill: "#ffb900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m588.099 334.113-9.49 1.828 3.358 23.717 8.328-2.884z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1289",
    style: {
      fill: "#30ffc7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m742.534 475.12 1.471-5.631 2.742 9.942-1.49 5.011z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1291",
    style: {
      fill: "#00bcff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m772.149 520.428 10.304-5.24 6.263-1.859-10.495 5.686z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1293",
    style: {
      fill: "#87ff70",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m821.803 439.956-7.116-12.681-.072-12.395 7.083 13.687z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1295",
    style: {
      fill: "#ff5900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m709.196 304.817-28.926-15.102-3.244 7.535 27.688 14.186z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1297",
    style: {
      fill: "#e7ff0f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m811.423 391.501-16.243-15.988-2.86-11.126 16.055 16.748z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1299",
    style: {
      fill: "#00d0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m748.699 510.846 9.596-4.59 5.594 4.616-9.757 4.57z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1301",
    style: {
      fill: "#ff6c00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m704.714 311.436-27.688-14.186-3.094 10.124 26.516 13.081z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1303",
    style: {
      fill: "#ff5d00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m599.278 296.208-17.472-2.85 3.437 19.417 15.732 1.765z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1305",
    style: {
      fill: "#0000c4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m485.185 629.213 1.8 7.912-13.335-11.645-2.183-8.246z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1307",
    style: {
      fill: "#e7ff0f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m730.028 380.54-18.125-11.122-2.815 14.127 17.835 9.723z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1309",
    style: {
      fill: "#00c4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m778.221 519.015 10.495-5.686 6.036-3.467-10.68 6.225z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1311",
    style: {
      fill: "#ffa700",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m784.192 346.68-23.523-17.915-4.532-6.318 22.994 18.14z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1313",
    style: {
      fill: "#ff1300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m595.18 267.025-21.602-4.627 4.303 14.009 19.447 3.814z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1315",
    style: {
      fill: "#0000e8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m471.467 617.234 2.183 8.246-12.426-14.804L458.68 602z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1317",
    style: {
      fill: "#36ffc1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m813.733 482.154 2.3-9.284 2.896-10.476-2.357 10.234z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1319",
    style: {
      fill: "#00e0fb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m743.787 504.943 9.455-4.737 5.053 6.05-9.596 4.59z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1321",
    style: {
      fill: "#ff3400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m597.328 280.221-19.447-3.814 3.925 16.95 17.472 2.851z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1323",
    style: {
      fill: "#fbf100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m581.967 359.658-3.59 5.008 3.048 25.325 2.822-5.897z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1325",
    style: {
      fill: "#0054ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m584.04 551.721 1.548 14.25-9.259 18.094-1.56-14.155z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1327",
    style: {
      fill: "#b00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m498.477 245.815-18.074 5.41 10.678-5.298 16.05-5.03z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1329",
    style: {
      fill: "#bf0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m564.324 244.648-21.779-2.31 7.098 7.381 19.373 1.998z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1331",
    style: {
      fill: "#ffb600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m719.64 344.68-23.128-13.052-3.499 13.02 22.438 11.696z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1333",
    style: {
      fill: "#ff6800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m745.854 316.848-27.539-17.43-4.544 1.358 26.606 16.962z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1335",
    style: {
      fill: "#0000ad",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m499.51 637.649 1.4 7.682-13.925-8.206-1.8-7.912z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1337",
    style: {
      fill: "#00b4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m425.154 528.466 3.719 12.222-6.258-24.031-3.853-12.73z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1339",
    style: {
      fill: "#53ffa4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m411.156 464.398 3.414 14.093-1.867-25.708-3.446-14.423z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1341",
    style: {
      fill: "#7dff7a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m741.74 436.139-5.894-8.064-.29 12.485 5.908 7.003z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1343",
    style: {
      fill: "#ff4e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m438.088 300.873-10.896 13.816 9.361-17.65 9.915-13.267z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1345",
    style: {
      fill: "#00d4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m784.072 516.087 10.68-6.225 5.658-4.99-10.86 6.844z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1347",
    style: {
      fill: "#0004ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m458.681 602 2.543 8.676-11.218-17.612-2.868-9.194z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1349",
    style: {
      fill: "#49ffad",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m740.76 465.142 1.467-6.366 1.778 10.713-1.471 5.63z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1351",
    style: {
      fill: "#c1ff36",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m581.425 389.991 1.261 7.573 1.89 26.087-1.611-8.274z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1353",
    style: {
      fill: "#0cf4eb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m739.523 497.88 9.335-5.006 4.384 7.332-9.455 4.737z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1355",
    style: {
      fill: "#c1ff36",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m739.472 403.504-12.55-10.236-2.212 13.4 12.45 8.946z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1357",
    style: {
      fill: "#ff9800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m724.359 334.742-23.911-14.287-3.936 11.173 23.128 13.051z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1359",
    style: {
      fill: "#ff7e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m585.243 312.775-10.984.832 4.35 22.334 9.49-1.828z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1361",
    style: {
      fill: "#ff6c00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m740.377 317.738-26.606-16.962-4.575 4.041 25.673 16.27z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1363",
    style: {
      fill: "#a7ff50",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m821.698 428.567-7.083-13.687-1.096-12.03 7.034 14.61z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1365",
    style: {
      fill: "#ffea00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m808.375 381.135-16.055-16.748-3.694-9.7 15.824 17.343z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1367",
    style: {
      fill: "#ffe600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m733.95 368.828-18.499-12.484-3.548 13.074 18.125 11.122z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1369",
    style: {
      fill: "#ff9400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m779.13 340.587-22.993-18.14-4.982-4.012 22.42 18.143z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1371",
    style: {
      fill: "#83ff73",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m584.576 423.651 4.57 9.387-.02 25.997-4.552-9.909z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1373",
    style: {
      fill: "#ff8200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m729.481 326.806-24.767-15.37-4.266 9.02 23.91 14.286z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1375",
    style: {
      fill: "#ff7300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m734.87 321.086-25.674-16.269-4.482 6.619 24.767 15.37z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1377",
    style: {
      fill: "#0000a4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m514.096 642.331.994 7.561-14.18-4.561-1.4-7.682z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1379",
    style: {
      fill: "#a40000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m535.456 238.93-19.148 1.184 9.452 3.409 16.785-1.184z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1381",
    style: {
      fill: "#50ffa7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m816.572 472.628 2.357-10.234 1.941-11.065-2.406 11.179z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1383",
    style: {
      fill: "#00e4f8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m789.55 511.716 10.86-6.845 5.135-6.392-11.027 7.53z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1385",
    style: {
      fill: "#cd0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m569.016 251.717-19.373-1.998 6.907 11.169 17.028 1.51z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1387",
    style: {
      fill: "#40ffb7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m589.126 459.035 6.107 10.39-2.46 25.115-5.843-10.763z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1389",
    style: {
      fill: "#1fffd7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m736.016 489.832 9.241-5.39 3.601 8.432-9.335 5.005z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1391",
    style: {
      fill: "#d7ff1f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m407.888 398.16 1.893 14.53 2.963-24.646-1.894-14.641z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1393",
    style: {
      fill: "#da0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m470.654 260.586-14.182 9.49 11.38-9.879 12.551-8.972z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1395",
    style: {
      fill: "#0000cd",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "M554.697 622.544 555.93 633l-13.273 7.005-1.489-10.284z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1397",
    style: {
      fill: "#003cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m447.138 583.87 2.868 9.195-9.733-20.005-3.155-9.79z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1399",
    style: {
      fill: "#ff4e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m581.806 293.357-12.773-.074 5.226 20.324 10.984-.832z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1401",
    style: {
      fill: "#9dff5a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m743.054 424.798-5.893-9.184-1.315 12.461 5.894 8.064z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1403",
    style: {
      fill: "#63ff94",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m739.988 454.762 1.476-7.199.763 11.213-1.466 6.366z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1405",
    style: {
      fill: "#e80000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m573.578 262.398-17.028-1.51 6.525 14.656 14.806.863z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1407",
    style: {
      fill: "#ffc400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m738.583 358.448-18.943-13.769-4.189 11.665 18.498 12.484z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1409",
    style: {
      fill: "#ffae00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m578.61 335.941-4.72 4.16 4.486 24.565 3.591-5.008z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1411",
    style: {
      fill: "#ff8600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m773.576 336.578-22.42-18.143-5.302-1.587 21.82 17.921z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1413",
    style: {
      fill: "#deff19",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m742.723 392.066-12.695-11.525-3.105 12.727 12.549 10.236z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1415",
    style: {
      fill: "#00e4f8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m592.773 494.54 3.482 12.646-4.982 23.458-3.278-12.823z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1417",
    style: {
      fill: "#f20",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m577.881 276.407-14.806-.863 5.958 17.739 12.773.074z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1419",
    style: {
      fill: "#0018ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m576.33 584.065 1.677 12.897-10.923 14.585-1.788-12.69z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1421",
    style: {
      fill: "#ffd000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m804.45 372.03-15.824-17.342-4.434-8.008 15.558 17.753z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1423",
    style: {
      fill: "#0ff8e7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m794.518 506.01 11.027-7.53 4.48-7.636-11.178 8.263z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1425",
    style: {
      fill: "#c1ff36",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m820.553 417.46-7.034-14.61-2.096-11.349 6.968 15.424z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1427",
    style: {
      fill: "#33ffc4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m733.358 481.001 9.176-5.881 2.723 9.322-9.24 5.39z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1429",
    style: {
      fill: "#0000a8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m528.596 643.13.588 7.554-14.094-.792-.994-7.561z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1431",
    style: {
      fill: "#6aff8d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m818.464 462.508 2.406-11.18.933-11.372-2.447 12.095z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1433",
    style: {
      fill: "#9f0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m507.131 240.897-16.05 5.03 11.324-1.05 13.903-4.763z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1435",
    style: {
      fill: "#00c8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m742.44 523.903 17.51-5.284 6.057 1.676-17.758 5.49z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1437",
    style: {
      fill: "#ffab00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m743.809 349.683-19.45-14.94-4.719 9.936 18.943 13.769z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1439",
    style: {
      fill: "#00d0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m736.858 520.61 17.274-5.167 5.819 3.176-17.51 5.284z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1441",
    style: {
      fill: "#ff8200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m767.673 334.77-21.819-17.922-5.477.89 21.205 17.477z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1443",
    style: {
      fill: "#16ffe1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m418.762 503.926 3.853 12.731-4.098-24.9-3.947-13.266z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1445",
    style: {
      fill: "#ff8d00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m419.863 335.234-3.652 15.085 7.652-20.785 3.33-14.845z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1447",
    style: {
      fill: "#00c8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m748.249 525.786 17.758-5.491 6.142.133-18.013 5.782z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1449",
    style: {
      fill: "#00d8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m731.641 515.991 17.058-5.145 5.433 4.597-17.274 5.168z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1451",
    style: {
      fill: "#a80000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m542.545 242.339-16.785 1.184 9.466 7.537 14.417-1.34z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1453",
    style: {
      fill: "#feed00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m578.376 364.666.56 6.906 3.75 25.992-1.261-7.572z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1455",
    style: {
      fill: "#ff9800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m749.487 342.773-20.006-15.967-5.122 7.936 19.45 14.941z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1457",
    style: {
      fill: "#ff8200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m761.582 335.215-21.205-17.477-5.508 3.348 20.596 16.82z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1459",
    style: {
      fill: "#7dff7a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m740.24 444.245 1.5-8.106-.276 11.424-1.476 7.199z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1461",
    style: {
      fill: "#baff3c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m745.377 413.839-5.905-10.335-2.311 12.11 5.893 9.184z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1463",
    style: {
      fill: "#fbf100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m746.832 381.607-12.883-12.779-3.92 11.713 12.694 11.525z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1465",
    style: {
      fill: "#00c8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m754.136 526.21 18.013-5.782 6.072-1.413-18.268 6.149z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1467",
    style: {
      fill: "#26ffd1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m798.847 499.107 11.178-8.263 3.708-8.69-11.31 9.026z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1469",
    style: {
      fill: "#02e8f4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m726.923 510.16 16.864-5.217 4.912 5.903-17.057 5.145z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1471",
    style: {
      fill: "#0078ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m437.118 563.27 3.155 9.79-8.006-21.925-3.394-10.447z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1473",
    style: {
      fill: "#ff8900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m755.465 337.906-20.596-16.82-5.388 5.72 20.006 15.967z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1475",
    style: {
      fill: "#ffb900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m799.75 364.433-15.558-17.753-5.061-6.093 15.264 17.965z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1477",
    style: {
      fill: "#0098ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m591.273 530.644 1.54 14.353-7.225 20.974-1.548-14.25z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1479",
    style: {
      fill: "#97ff60",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m409.257 438.36 3.446 14.423.533-25.338-3.455-14.755z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1481",
    style: {
      fill: "#ff7300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m574.26 313.607-6.18 3.376 5.81 23.118 4.72-4.16z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1483",
    style: {
      fill: "#4dffaa",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m731.62 471.611 9.14-6.47 1.774 9.979-9.176 5.881z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1485",
    style: {
      fill: "#deff19",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m818.391 406.925-6.968-15.424-3.048-10.366 6.89 16.108z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1487",
    style: {
      fill: "#ff1a00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m446.468 283.772-9.915 13.268 11.17-14.247 8.75-12.716z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1489",
    style: {
      fill: "#00d0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m759.953 525.164 18.268-6.15 5.85-2.927-18.518 6.584z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1491",
    style: {
      fill: "#13fce4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m722.822 503.263 16.701-5.384 4.264 7.064-16.864 5.217z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1493",
    style: {
      fill: "#87ff70",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m819.356 452.05 2.447-12.094-.105-11.389-2.477 12.96z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1495",
    style: {
      fill: "#c4ff33",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m582.686 397.564 4.279 8.91 2.181 26.564-4.57-9.387z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1497",
    style: {
      fill: "#b60000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m549.643 249.72-14.417 1.34 9.216 11.477 12.108-1.65z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1499",
    style: {
      fill: "gold",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m751.694 372.409-13.11-13.961-4.635 10.38 12.883 12.78z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1501",
    style: {
      fill: "#ffa700",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m794.395 358.552-15.264-17.965-5.555-4.009 14.95 17.972z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1503",
    style: {
      fill: "#0000fa",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m567.084 611.547.996 10.704-12.15 10.748-1.233-10.455z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1505",
    style: {
      fill: "#00b",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m542.656 640.004.194 7.66-13.666 3.02-.588-7.554z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1507",
    style: {
      fill: "#3cffba",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m802.423 491.18 11.31-9.026 2.839-9.526-11.42 9.802z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1509",
    style: {
      fill: "#00dcfe",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m765.553 522.67 18.519-6.583 5.479-4.37-18.757 7.074z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1511",
    style: {
      fill: "#d4ff23",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m748.652 403.55-5.93-11.484-3.25 11.438 5.905 10.335z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1513",
    style: {
      fill: "#ff3f00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m569.033 293.283-7.93 2.683 6.977 21.017 6.18-3.376z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1515",
    style: {
      fill: "#9aff5d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m741.515 433.864 1.539-9.066-1.314 11.34-1.5 8.107z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1517",
    style: {
      fill: "#b20000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m480.403 251.225-12.551 8.972 12.46-5.75 10.77-8.52z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1519",
    style: {
      fill: "#0000d6",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m486.985 637.125.604 5.05-12.843-11.217-1.096-5.478z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1521",
    style: {
      fill: "#26ffd1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m719.444 495.472 16.572-5.64 3.507 8.047-16.701 5.384z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1523",
    style: {
      fill: "#0000fa",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m473.65 625.48 1.096 5.478-11.967-14.255-1.555-6.027z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1525",
    style: {
      fill: "#63ff94",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m730.849 461.899 9.139-7.137.773 10.38-9.141 6.469z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1527",
    style: {
      fill: "#83ff73",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m589.146 433.038 6.132 10.081-.045 26.306-6.107-10.39z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1529",
    style: {
      fill: "#d60000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m556.55 260.888-12.108 1.65 8.707 15.108 9.926-2.102z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1531",
    style: {
      fill: "#960000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m516.308 240.114-13.903 4.764 11.662 3.267 11.693-4.622z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1533",
    style: {
      fill: "#f4f802",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m815.266 397.243-6.891-16.108-3.925-9.105 6.804 16.641z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1535",
    style: {
      fill: "#ff1300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m563.075 275.544-9.926 2.102 7.953 18.32 7.931-2.683z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1537",
    style: {
      fill: "#0000bf",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m500.91 645.33.09 4.75-13.41-7.906-.605-5.049z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1539",
    style: {
      fill: "#ffc100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m757.18 364.72-13.371-15.037-5.226 8.765 13.11 13.96z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1541",
    style: {
      fill: "#ffd000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m410.85 373.403 1.894 14.641 5.36-22.974-1.893-14.75z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1543",
    style: {
      fill: "#ff9c00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m788.525 354.55-14.95-17.972-5.902-1.809 14.624 17.771z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1545",
    style: {
      fill: "#a0ff56",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m819.22 441.527 2.478-12.96-1.145-11.107-2.497 13.75z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1547",
    style: {
      fill: "#ffab00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m573.89 340.1-.478 6.294 5.524 25.178-.56-6.906z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1549",
    style: {
      fill: "#0014ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m461.224 610.676 1.555 6.027-10.801-16.954-1.972-6.684z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1551",
    style: {
      fill: "#06ecf1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m770.794 518.79 18.757-7.074 4.967-5.707-18.977 7.609z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1553",
    style: {
      fill: "#00bcff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m428.873 540.688 3.394 10.447-6.072-23.324-3.58-11.154z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1555",
    style: {
      fill: "#0054ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m585.588 565.971 1.586 13.144-9.167 17.847-1.678-12.897z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1557",
    style: {
      fill: "#39ffbe",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m716.877 486.982 16.481-5.98 2.658 8.83-16.572 5.64z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1559",
    style: {
      fill: "#ffae00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m763.148 358.753-13.661-15.98-5.678 6.91 13.372 15.038z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1561",
    style: {
      fill: "#40ffb7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m595.233 469.425 3.592 12.505-2.57 25.256-3.482-12.646z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1563",
    style: {
      fill: "#ff9800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m782.297 352.54-14.624-17.77-6.091.445 14.295 17.364z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1565",
    style: {
      fill: "#56ffa0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m414.57 478.491 3.947 13.266-1.815-25.16-3.999-13.814z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1567",
    style: {
      fill: "#53ffa4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m805.152 482.43 11.42-9.801 1.892-10.121-11.505 10.568z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1569",
    style: {
      fill: "#eeff09",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m752.799 394.207-5.967-12.6-4.11 10.46 5.93 11.483z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1571",
    style: {
      fill: "#ff9f00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m769.436 354.669-13.971-16.763-5.978 4.867 13.66 15.98z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1573",
    style: {
      fill: "#ff9800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m775.877 352.58-14.295-17.365-6.117 2.691 13.971 16.763z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1575",
    style: {
      fill: "#b4ff43",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m743.786 423.89 1.59-10.051-2.322 10.96-1.539 9.065z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1577",
    style: {
      fill: "#0000b6",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m515.09 649.892-.434 4.588-13.656-4.4-.09-4.75z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1579",
    style: {
      fill: "#00d8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m713.224 526.39 23.634-5.78 5.583 3.293-23.897 5.928z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1581",
    style: {
      fill: "#ffde00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m811.254 388.671-6.804-16.641-4.7-7.597 6.708 17.01z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1583",
    style: {
      fill: "#7dff7a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m731.07 452.113 9.17-7.868-.252 10.517-9.139 7.137z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1585",
    style: {
      fill: "#00d0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m718.544 529.831 23.897-5.928 5.808 1.883-24.173 6.132z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1587",
    style: {
      fill: "#00e0fb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m708.248 521.685 23.393-5.694 5.217 4.62-23.634 5.78z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1589",
    style: {
      fill: "#00d0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m724.076 531.918 24.173-6.132 5.887.424-24.457 6.389z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1591",
    style: {
      fill: "#ff4e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m427.192 314.69-3.329 14.844 9.77-17.909 2.92-14.585z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1593",
    style: {
      fill: "#09f0ee",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m703.743 515.831 23.18-5.67 4.719 5.83-23.394 5.694z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1595",
    style: {
      fill: "#19ffde",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m775.54 513.618 18.978-7.609 4.329-6.902-19.176 8.172z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1597",
    style: {
      fill: "#0048ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m450.006 593.064 1.972 6.685-9.37-19.253-2.335-7.436z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1599",
    style: {
      fill: "#50ffa7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m715.19 478.008 16.43-6.397 1.738 9.39-16.48 5.98z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1601",
    style: {
      fill: "#beff39",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m818.056 431.21 2.497-13.75-2.162-10.535-2.503 14.447z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1603",
    style: {
      fill: "#960000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m525.76 243.523-11.693 4.622 11.678 7.522 9.481-4.607z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1605",
    style: {
      fill: "#ffe600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m757.71 386.06-6.016-13.651-4.862 9.198 5.967 12.6z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1607",
    style: {
      fill: "#0000da",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m555.93 632.999-.182 7.88-12.898 6.786-.194-7.661z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1609",
    style: {
      fill: "#00d0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m729.679 532.599 24.457-6.389 5.817-1.046-24.74 6.69z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1611",
    style: {
      fill: "#ffea00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m578.936 371.572 3.682 8.489 4.347 26.412-4.279-8.91z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1613",
    style: {
      fill: "#16ffe1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m699.824 508.976 22.998-5.713 4.1 6.897-23.179 5.671z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1615",
    style: {
      fill: "#ff6c00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m568.08 316.983-1.826 5.754 7.158 23.657.478-6.293z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1617",
    style: {
      fill: "#d7ff1f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m409.78 412.69 3.456 14.755 2.946-24.32-3.438-15.081z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1619",
    style: {
      fill: "#6dff8a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m806.96 473.076 11.504-10.568.892-10.457-11.562 11.309z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1621",
    style: {
      fill: "#d10000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m456.472 270.077-8.749 12.716 12.698-10.42 7.43-12.176z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1623",
    style: {
      fill: "#fc0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m806.458 381.443-6.708-17.01-5.355-5.881 6.609 17.203z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1625",
    style: {
      fill: "#00e4f8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m596.255 507.186 1.537 14.462-4.979 23.35-1.54-14.354z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1627",
    style: {
      fill: "#ceff29",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m746.997 414.585 1.655-11.035-3.275 10.289-1.591 10.05z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1629",
    style: {
      fill: "#960000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m491.081 245.927-10.77 8.52 13.21-1.424 8.884-8.145z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1631",
    style: {
      fill: "#97ff60",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m732.282 442.507 9.233-8.643-1.275 10.381-9.17 7.868z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1633",
    style: {
      fill: "#00b",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m529.184 650.684-.956 4.567-13.572-.771.434-4.588z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1635",
    style: {
      fill: "#00d8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m735.212 531.853 24.74-6.69 5.601-2.492-25.018 7.027z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1637",
    style: {
      fill: "#0020ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m578.007 596.962.788 11.029-10.715 14.26-.996-10.704z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1639",
    style: {
      fill: "#29ffce",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m779.671 507.28 19.176-8.173 3.576-7.927-19.347 8.754z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1641",
    style: {
      fill: "#29ffce",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m696.59 501.291 22.854-5.82 3.378 7.792-22.998 5.713z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1643",
    style: {
      fill: "#ffd000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m763.257 379.329-6.076-14.608-5.487 7.688 6.016 13.65z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1645",
    style: {
      fill: "#66ff90",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m714.426 468.777 16.423-6.878.77 9.712-16.43 6.397z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1647",
    style: {
      fill: "#d4ff23",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m815.888 421.372 2.503-14.447-3.125-9.682-2.497 15.03z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1649",
    style: {
      fill: "#ffb900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m801.004 375.755-6.61-17.203-5.869-4.002 6.51 17.212z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1651",
    style: {
      fill: "#a80000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m535.226 251.06-9.48 4.607 11.367 11.59 7.33-4.72z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1653",
    style: {
      fill: "#19ffde",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m422.615 516.657 3.58 11.154-3.97-24.16-3.708-11.894z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1655",
    style: {
      fill: "#c4ff33",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m586.965 406.473 5.914 9.845 2.4 26.801-6.133-10.081z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1657",
    style: {
      fill: "#ff3400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m561.102 295.966-3.447 5.302 8.6 21.469 1.825-5.754z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1659",
    style: {
      fill: "#0080ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m440.273 573.06 2.335 7.436-7.704-21.096-2.637-8.265z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1661",
    style: {
      fill: "#ffc100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m769.296 374.2-6.148-15.447-5.967 5.968 6.076 14.608z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1663",
    style: {
      fill: "#00e4f8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m740.535 529.698 25.018-7.027 5.24-3.88-25.28 7.391z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1665",
    style: {
      fill: "#87ff70",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m807.794 463.36 11.562-11.31-.135-10.523-11.59 12.004z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1667",
    style: {
      fill: "#3cffba",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m694.124 492.97 22.753-5.988 2.567 8.49-22.855 5.819z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1669",
    style: {
      fill: "#e4ff13",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m751.067 406.196 1.732-11.99-4.147 9.344-1.655 11.035z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1671",
    style: {
      fill: "#ffb200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m795.034 371.762-6.509-17.212-6.228-2.01 6.41 17.035z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1673",
    style: {
      fill: "#c80000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m544.442 262.537-7.33 4.72 10.738 15.342 5.3-4.953z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1675",
    style: {
      fill: "#f10800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m553.15 277.646-5.3 4.953 9.805 18.67 3.447-5.303z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1677",
    style: {
      fill: "#b1ff46",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m734.457 433.33 9.329-9.44-2.27 9.974-9.234 8.643z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1679",
    style: {
      fill: "#ffb200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m775.664 370.81-6.228-16.141-6.288 4.084 6.148 15.446z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1681",
    style: {
      fill: "#ff8d00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m416.211 350.32 1.892 14.75 7.645-20.68-1.885-14.856z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1683",
    style: {
      fill: "#40ffb7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m783.076 499.934 19.347-8.754 2.729-8.75-19.486 9.336z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1685",
    style: {
      fill: "#ffab00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m788.708 369.575-6.41-17.035-6.421.04 6.316 16.674z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1687",
    style: {
      fill: "#ffae00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m782.193 369.255-6.316-16.676-6.441 2.09 6.228 16.141z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1689",
    style: {
      fill: "#7dff7a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m714.612 459.525 16.458-7.412-.221 9.786-16.423 6.878z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1691",
    style: {
      fill: "#00dcfe",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m684.869 532.839 28.355-6.448 5.32 3.44-28.626 6.645z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1693",
    style: {
      fill: "#00e4f8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m680.143 527.964 28.105-6.279 4.976 4.706-28.355 6.448z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1695",
    style: {
      fill: "#97ff60",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m412.703 452.783 3.999 13.815.537-24.79-4.003-14.363z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1697",
    style: {
      fill: "#ebff0c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m812.77 412.272 2.496-15.03-4.012-8.57-2.476 15.484z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1699",
    style: {
      fill: "#0000ed",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m487.59 642.174-.581 2.008-12.256-10.703-.008-2.52z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1701",
    style: {
      fill: "#009cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m592.813 544.997 1.516 13.425-7.155 20.693-1.586-13.144z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1703",
    style: {
      fill: "#83ff73",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m595.278 443.12 3.607 12.406-.06 26.404-3.592-12.505z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1705",
    style: {
      fill: "#00d4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m689.918 536.476 28.626-6.645 5.532 2.087-28.913 6.865z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1707",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m474.746 630.958.008 2.52-11.42-13.6-.555-3.175z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1709",
    style: {
      fill: "#ffa300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m573.412 346.394 2.793 8.135 6.413 25.532-3.682-8.489z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1711",
    style: {
      fill: "#0cf4eb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m675.86 521.974 27.883-6.143 4.505 5.854-28.105 6.279z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1713",
    style: {
      fill: "#0cf4eb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m745.512 526.182 25.282-7.391 4.747-5.173-25.526 7.775z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1715",
    style: {
      fill: "#0000cd",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m542.85 647.665-1.466 4.69-13.156 2.896.956-4.567z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1717",
    style: {
      fill: "#50ffa7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m692.492 484.22 22.697-6.212 1.688 8.974-22.753 5.987z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1719",
    style: {
      fill: "#0000d6",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m501 650.08-1.195 1.648-12.796-7.546.58-2.008z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1721",
    style: {
      fill: "#f8f500",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m755.894 398.95 1.816-12.89-4.911 8.147-1.732 11.99z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1723",
    style: {
      fill: "#00d4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m695.163 538.783 28.913-6.865 5.603.68-29.207 7.102z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1725",
    style: {
      fill: "#890000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m502.405 244.878-8.884 8.145 13.598 2.979 6.948-7.857z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1727",
    style: {
      fill: "#19ffde",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m672.127 515.018 27.697-6.042 3.92 6.855-27.884 6.143z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1729",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m568.08 622.251-.525 8.213-11.807 10.416.181-7.882z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1731",
    style: {
      fill: "#a0ff56",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m807.63 453.531 11.59-12.004-1.164-10.317-11.587 12.637z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1733",
    style: {
      fill: "#0024ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m462.779 616.703.555 3.175-10.305-16.174-1.051-3.955z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1735",
    style: {
      fill: "#ff1600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m436.553 297.04-2.92 14.585 11.655-14.516 2.435-14.316z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1737",
    style: {
      fill: "#c7ff30",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m737.543 424.825 9.454-10.24-3.211 9.305-9.329 9.44z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1739",
    style: {
      fill: "#feed00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m808.778 404.156 2.476-15.485-4.796-7.228-2.44 15.796z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1741",
    style: {
      fill: "#56ffa0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m785.666 491.766 19.486-9.336 1.807-9.354-19.59 9.908z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1743",
    style: {
      fill: "#a80000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m467.852 260.197-7.431 12.176 13.896-6.267 5.995-11.66z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1745",
    style: {
      fill: "#00d4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m700.472 539.7 29.207-7.101 5.533-.746-29.501 7.348z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1747",
    style: {
      fill: "#97ff60",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m715.746 450.491 16.536-7.984-1.212 9.606-16.458 7.412z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1749",
    style: {
      fill: "#29ffce",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m669.04 507.272 27.55-5.981 3.234 7.685-27.697 6.042z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1751",
    style: {
      fill: "#00c4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m432.267 551.135 2.637 8.265-5.839-22.434-2.87-9.155z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1753",
    style: {
      fill: "#1cffdb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m750.015 521.393 25.526-7.775 4.13-6.339-25.744 8.169z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1755",
    style: {
      fill: "#0000cd",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m514.656 654.48-1.822 1.447-13.029-4.2 1.195-1.646z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1757",
    style: {
      fill: "#66ff90",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m691.74 475.266 22.686-6.49.763 9.232-22.697 6.212z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1759",
    style: {
      fill: "#ffde00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m761.352 393.04 1.905-13.711-5.547 6.73-1.816 12.89z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1761",
    style: {
      fill: "#ffd300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m412.744 388.044 3.438 15.08 5.316-22.661-3.395-15.393z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1763",
    style: {
      fill: "#40ffb7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m598.825 481.93 1.539 14.575-2.572 25.143-1.537-14.462z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1765",
    style: {
      fill: "#00dcfe",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m705.71 539.201 29.502-7.348 5.323-2.155-29.789 7.598z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1767",
    style: {
      fill: "#ffdb00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m804.018 397.24 2.44-15.797-5.454-5.688-2.392 15.956z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1769",
    style: {
      fill: "#b7ff40",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m806.469 443.847 11.587-12.637-2.168-9.838-11.554 13.19z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1771",
    style: {
      fill: "#ffe600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m582.618 380.06 5.456 9.685 4.805 26.573-5.914-9.845z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1773",
    style: {
      fill: "#0054ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m451.978 599.749 1.05 3.955-8.937-18.363-1.483-4.845z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1775",
    style: {
      fill: "#56ffa0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m418.517 491.757 3.708 11.895-1.75-24.402-3.773-12.652z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1777",
    style: {
      fill: "#3cffba",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m666.68 498.929 27.444-5.96 2.465 8.322-27.548 5.98z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1779",
    style: {
      fill: "#005cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m587.174 579.115.612 11.422-8.991 17.454-.788-11.03z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1781",
    style: {
      fill: "#ff6400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m566.254 322.737 1.634 7.858 8.317 23.934-2.793-8.135z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1783",
    style: {
      fill: "#ffd000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m767.298 388.63 1.998-14.43-6.039 5.129-1.905 13.712z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1785",
    style: {
      fill: "#deff19",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m741.464 417.215 9.603-11.019-4.07 8.389-9.454 10.24z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1787",
    style: {
      fill: "#890000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m514.067 248.145-6.948 7.857 13.612 7.328 5.014-7.663z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1789",
    style: {
      fill: "#6dff8a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m787.37 482.984 19.59-9.908.834-9.716-19.655 10.451z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1791",
    style: {
      fill: "#fc0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m798.612 391.711 2.392-15.956-5.97-3.993-2.33 15.96z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1793",
    style: {
      fill: "#adff49",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m717.802 441.91 16.655-8.58-2.175 9.177-16.536 7.984z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1795",
    style: {
      fill: "#2cffca",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m753.927 515.448 25.744-8.169 3.405-7.345-25.93 8.56z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1797",
    style: {
      fill: "#7dff7a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m691.888 466.335 22.724-6.81-.186 9.252-22.686 6.49z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1799",
    style: {
      fill: "#00dcfe",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m655.467 542.502 31.894-7.684-4.903-4.269-31.97 7.615z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1801",
    style: {
      fill: "#02e8f4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m650.487 538.164 31.97-7.615-4.518-5.45-32.05 7.53z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1803",
    style: {
      fill: "#ffc400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m773.575 385.84 2.089-15.03-6.368 3.39-1.998 14.43z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1805",
    style: {
      fill: "#0000ed",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m555.748 640.88-1.95 4.956-12.414 6.519 1.466-4.69z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1807",
    style: {
      fill: "#02e8f4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m710.746 537.296 29.79-7.598 4.976-3.516-30.062 7.847z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1809",
    style: {
      fill: "#00d4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m660.704 545.534 31.82-7.734-5.163-2.982-31.894 7.684z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1811",
    style: {
      fill: "#0000d1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m528.228 655.25-2.45 1.415-12.944-.738 1.822-1.447z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1813",
    style: {
      fill: "#ffc400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m792.704 387.721 2.33-15.96-6.326-2.186-2.259 15.803z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1815",
    style: {
      fill: "#53ffa4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m665.106 490.2 27.386-5.98 1.632 8.75-27.444 5.959z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1817",
    style: {
      fill: "#0ff8e7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m645.89 532.63 32.049-7.53-4.02-6.494-32.128 7.43z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1819",
    style: {
      fill: "#ffc100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m780.016 384.745 2.177-15.49-6.53 1.555-2.088 15.03z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1821",
    style: {
      fill: "#ceff29",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m804.334 434.562 11.554-13.19-3.119-9.1-11.489 13.65z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1823",
    style: {
      fill: "#ffbd00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m786.45 385.378 2.258-15.803-6.515-.32-2.177 15.49z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1825",
    style: {
      fill: "#00d4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m666.066 547.181 31.752-7.764-5.294-1.617-31.82 7.734z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1827",
    style: {
      fill: "#f1fc06",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m746.12 410.706 9.774-11.757-4.827 7.247-9.603 11.02z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1829",
    style: {
      fill: "#ff2d00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m557.655 301.268.232 7.668 10 21.66-1.633-7.86z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1831",
    style: {
      fill: "#1cffdb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m641.79 526.035 32.128-7.429-3.42-7.374-32.203 7.316z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1833",
    style: {
      fill: "#ff4e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m423.863 329.534 1.885 14.856 9.76-17.81-1.874-14.955z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1835",
    style: {
      fill: "#c4ff33",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m592.88 416.318 3.523 12.349 2.482 26.859-3.607-12.407z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1837",
    style: {
      fill: "#9b0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m525.745 255.667-5.014 7.663 13.243 11.493 3.139-7.567z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1839",
    style: {
      fill: "#d4ff23",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m413.236 427.445 4.003 14.364 2.906-23.784-3.963-14.9z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1841",
    style: {
      fill: "#008cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m442.608 580.496 1.483 4.845-7.347-20.115-1.84-5.826z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1843",
    style: {
      fill: "#87ff70",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m788.14 473.811 19.654-10.451-.163-9.829-19.68 10.956z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1845",
    style: {
      fill: "#00d4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m671.418 547.4 31.69-7.772-5.29-.21-31.752 7.763z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1847",
    style: {
      fill: "#8d0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m480.312 254.446-5.995 11.66 14.722-1.902 4.482-11.181z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1849",
    style: {
      fill: "#c4ff33",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m720.732 434.006 16.811-9.181-3.086 8.506-16.655 8.579z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1851",
    style: {
      fill: "#43ffb4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m757.145 508.494 25.931-8.56 2.59-8.168-26.082 8.941z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1853",
    style: {
      fill: "#0ff8e7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m715.45 534.029 30.062-7.847 4.503-4.789-30.314 8.085z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1855",
    style: {
      fill: "#0028ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m578.795 607.99-.832 8.65-10.408 13.824.525-8.213z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1857",
    style: {
      fill: "#02e8f4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m597.792 521.648 1.468 13.733-4.931 23.04-1.516-13.424z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1859",
    style: {
      fill: "#94ff63",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m692.937 457.658 22.809-7.167-1.134 9.034-22.724 6.81z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1861",
    style: {
      fill: "#1cffdb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m426.195 527.811 2.87 9.155-3.813-23.229-3.027-10.085z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1863",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m487.009 644.182-1.34-1.026-11.587-10.12.671.443z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1865",
    style: {
      fill: "#66ff90",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m664.363 481.305 27.377-6.039.752 8.954-27.386 5.98z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1867",
    style: {
      fill: "#0010ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m474.753 633.479-.671-.443-10.797-12.86.05-.298z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1869",
    style: {
      fill: "#30ffc7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m638.295 518.548 32.203-7.316-2.733-8.07-32.274 7.193z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1871",
    style: {
      fill: "#e4ff13",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m801.28 425.922 11.49-13.65-3.992-8.116-11.395 14.001z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1873",
    style: {
      fill: "#e80000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m547.85 282.599-1.374 7.57 11.411 18.767-.232-7.668z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1875",
    style: {
      fill: "#b00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m537.113 267.256-3.14 7.567 12.503 15.345 1.374-7.569z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1877",
    style: {
      fill: "#d10000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m447.723 282.793-2.435 14.316 13.243-10.693 1.89-14.043z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1879",
    style: {
      fill: "#feed00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m751.389 405.472 9.963-12.431-5.458 5.908-9.775 11.757z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1881",
    style: {
      fill: "#0000f1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m499.805 651.728-2.037-1.438-12.098-7.134 1.339 1.026z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1883",
    style: {
      fill: "#ff9f00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m576.205 354.53 4.765 9.603 7.104 25.612-5.456-9.684z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1885",
    style: {
      fill: "#00d8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m676.625 546.183 31.637-7.76-5.153 1.205-31.69 7.772z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1887",
    style: {
      fill: "#0038ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m463.334 619.878-.05.298-9.742-15.291-.513-1.181z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1889",
    style: {
      fill: "#0000e3",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m541.384 652.355-3.06 1.55-12.545 2.76 2.449-1.414z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1891",
    style: {
      fill: "#9dff5a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m787.95 464.487 19.68-10.956-1.161-9.684-19.665 11.406z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1893",
    style: {
      fill: "#43ffb4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m635.49 510.355 32.275-7.193-1.974-8.563-32.34 7.063z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1895",
    style: {
      fill: "#f4f802",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m797.383 418.157 11.395-14.001-4.76-6.917-11.273 14.238z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1897",
    style: {
      fill: "#1fffd7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m719.7 529.478 30.315-8.085 3.912-5.945-30.539 8.307z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1899",
    style: {
      fill: "#d7ff1f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m724.461 426.99 17.003-9.775-3.92 7.61-16.812 9.181z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1901",
    style: {
      fill: "#00d8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m622.618 550.997 32.849-8.495-4.98-4.338-33.05 8.318z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1903",
    style: {
      fill: "#56ffa0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m759.584 500.707 26.082-8.94 1.704-8.783-26.193 9.301z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1905",
    style: {
      fill: "#00e4f8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m617.437 546.482 33.05-8.318-4.597-5.535-33.244 8.095z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1907",
    style: {
      fill: "#ffde00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m757.135 401.658 10.163-13.028-5.946 4.41-9.963 12.432z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1909",
    style: {
      fill: "#7dff7a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m664.473 472.473 27.415-6.138-.148 8.931-27.377 6.04z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1911",
    style: {
      fill: "#aaff4d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m694.865 449.46 22.937-7.55-2.056 8.581-22.809 7.167z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1913",
    style: {
      fill: "#0000e8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m512.834 655.927-2.752-1.669-12.314-3.968 2.037 1.438z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1915",
    style: {
      fill: "#00d0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m628.058 554.154 32.646-8.62-5.237-3.032-32.849 8.495z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1917",
    style: {
      fill: "#94ff63",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m416.702 466.598 3.772 12.652.537-24.033-3.772-13.408z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1919",
    style: {
      fill: "#0cf4eb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m612.646 540.724 33.244-8.095-4.1-6.594-33.424 7.83z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1921",
    style: {
      fill: "#00e4f8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m681.554 543.556 31.594-7.728-4.886 2.594-31.637 7.761z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1923",
    style: {
      fill: "#83ff73",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m598.885 455.526 1.545 14.686-.066 26.293-1.539-14.575z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1925",
    style: {
      fill: "#ff9100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m418.103 365.07 3.395 15.393 7.578-20.392-3.328-15.681z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1927",
    style: {
      fill: "#0008ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m567.555 630.464-2.398 5.361-11.359 10.011 1.95-4.956z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1929",
    style: {
      fill: "#ffe600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m792.745 411.477 11.273-14.238-5.406-5.528-11.125 14.35z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1931",
    style: {
      fill: "#0cf",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m633.621 555.873 32.445-8.692-5.362-1.647-32.646 8.62z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1933",
    style: {
      fill: "#00a0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m594.329 558.422.474 11.876-7.017 20.24-.612-11.423z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1935",
    style: {
      fill: "#0cf",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m434.904 559.4 1.84 5.826-5.564-21.384-2.115-6.876z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1937",
    style: {
      fill: "#ffd300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m763.207 399.366 10.368-13.527-6.277 2.791-10.163 13.028z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1939",
    style: {
      fill: "#0064ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m453.029 603.704.513 1.18-8.45-17.357-1.001-2.186z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1941",
    style: {
      fill: "#1cffdb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m608.366 533.865 33.425-7.83-3.496-7.487-33.59 7.53z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1943",
    style: {
      fill: "#5aff9d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m633.451 501.662 32.34-7.063-1.162-8.84-32.397 6.93z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1945",
    style: {
      fill: "maroon",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m493.52 253.023-4.48 11.181 15.147 2.55 2.932-10.752z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1947",
    style: {
      fill: "#b4ff43",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m786.804 455.253 19.665-11.406-2.135-9.285-19.607 11.792z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1949",
    style: {
      fill: "#ffdb00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m787.487 406.06 11.125-14.349-5.908-3.99-10.957 14.333z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1951",
    style: {
      fill: "#e7ff0f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m728.897 421.048 17.222-10.342-4.655 6.51-17.003 9.774z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1953",
    style: {
      fill: "#ffd000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m769.444 398.662 10.572-13.917-6.441 1.094-10.368 13.527z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1955",
    style: {
      fill: "#00d0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m639.167 556.108 32.251-8.708-5.352-.219-32.445 8.692z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1957",
    style: {
      fill: "#30ffc7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m723.388 523.755 30.54-8.307 3.217-6.954-30.73 8.508z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1959",
    style: {
      fill: "#ffd000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m781.747 402.054 10.957-14.333-6.255-2.343-10.77 14.187z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1961",
    style: {
      fill: "#fc0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m775.68 399.565 10.77-14.187-6.434-.633-10.572 13.917z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1963",
    style: {
      fill: "#6dff8a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m761.177 492.285 26.193-9.301.77-9.173-26.262 9.634z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1965",
    style: {
      fill: "#94ff63",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m665.436 463.929 27.501-6.271-1.049 8.677-27.415 6.138z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1967",
    style: {
      fill: "#c1ff36",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m697.623 441.954 23.109-7.948-2.93 7.904-22.937 7.55z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1969",
    style: {
      fill: "#0cf4eb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m686.078 539.582 31.561-7.675-4.491 3.921-31.594 7.728z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1971",
    style: {
      fill: "#2cffca",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m604.704 526.078 33.59-7.53-2.803-8.193-33.735 7.203z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1973",
    style: {
      fill: "#ff6000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m567.888 330.595 3.859 9.603 9.223 23.935-4.765-9.604z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1975",
    style: {
      fill: "#ffe600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m588.074 389.745 3.344 12.333 4.985 26.589-3.524-12.349z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1977",
    style: {
      fill: "#0000ed",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m525.779 656.665-3.464-1.712-12.233-.695 2.752 1.67z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1979",
    style: {
      fill: "#56ffa0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m422.225 503.652 3.027 10.085-1.675-23.453-3.103-11.034z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1981",
    style: {
      fill: "#6dff8a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m632.232 492.689 32.397-6.93-.318-8.892-32.446 6.796z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1983",
    style: {
      fill: "#00d4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m644.554 554.85 32.07-8.667-5.206 1.217-32.251 8.708z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1985",
    style: {
      fill: "#ff1a00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m433.634 311.625 1.873 14.954 11.638-14.43-1.857-15.04z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1987",
    style: {
      fill: "#caff2c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m784.727 446.354 19.607-11.792-3.054-8.64-19.51 12.104z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1989",
    style: {
      fill: "#000cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m485.67 643.156-1.307-3.871-10.86-9.484.579 3.235z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1991",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m553.798 645.836-3.642 1.856-11.833 6.214 3.061-1.551z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1993",
    style: {
      fill: "#00d0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m590.786 560.339 31.832-9.342-5.18-4.515-32.154 9.06z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1995",
    style: {
      fill: "#00dcfe",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m585.284 555.542 32.153-9.06-4.79-5.758-32.46 8.703z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1997",
    style: {
      fill: "#0028ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m474.082 633.036-.578-3.235-10.119-12.052-.1 2.427z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1999",
    style: {
      fill: "#f8f500",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m733.924 416.342 17.465-10.87-5.27 5.234-17.222 10.342z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2001",
    style: {
      fill: "#a40000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m460.42 272.373-1.889 14.043 14.489-6.537 1.297-13.773z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2003",
    style: {
      fill: "#00c8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m596.555 563.695 31.503-9.54-5.44-3.158-31.832 9.342z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2005",
    style: {
      fill: "#0064ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m587.786 590.537-1.092 9.181-8.731 16.921.832-8.648z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2007",
    style: {
      fill: "gold",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m416.182 403.125 3.963 14.9 5.228-22.154-3.875-15.408z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2009",
    style: {
      fill: "#0098ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m444.09 585.341 1.003 2.186-6.943-19.009-1.406-3.292z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2011",
    style: {
      fill: "#43ffb4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m601.756 517.558 33.735-7.203-2.04-8.693-33.854 6.857z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2013",
    style: {
      fill: "#06ecf1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m580.188 549.427 32.458-8.703-4.28-6.859-32.74 8.28z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2015",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m497.768 650.29-2.069-4.322-11.336-6.683 1.307 3.87z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2017",
    style: {
      fill: "#43ffb4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m726.414 517.002 30.731-8.508 2.44-7.787-30.886 8.683z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2019",
    style: {
      fill: "#83ff73",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m761.878 483.445 26.261-9.634-.189-9.324-26.284 9.928z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2021",
    style: {
      fill: "#840000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m507.12 256.002-2.933 10.752 15.152 6.957 1.392-10.38z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2023",
    style: {
      fill: "#19ffde",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m690.08 534.356 31.541-7.602-3.982 5.153-31.561 7.675z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2025",
    style: {
      fill: "#40ffb7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m600.364 496.505 1.447 14.063-2.55 24.813-1.47-13.733z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2027",
    style: {
      fill: "#00c4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m602.447 565.527 31.174-9.654-5.563-1.719-31.503 9.541z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2029",
    style: {
      fill: "#d4ff23",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m701.145 435.341 23.316-8.351-3.73 7.016-23.108 7.948z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2031",
    style: {
      fill: "#aaff4d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m667.23 455.895 27.635-6.436-1.928 8.199-27.501 6.27z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2033",
    style: {
      fill: "#004cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m463.285 620.176.1-2.427-9.13-14.331-.713 1.467z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2035",
    style: {
      fill: "#00e0fb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m649.647 552.125 31.907-8.569-4.93 2.627-32.07 8.667z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2037",
    style: {
      fill: "#16ffe1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m575.625 542.145 32.74-8.28-3.66-7.787-32.993 7.8z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2039",
    style: {
      fill: "#deff19",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m781.77 438.026 19.51-12.104-3.897-7.765-19.373 12.332z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2041",
    style: {
      fill: "#ff2900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m557.887 308.936 2.759 9.682 11.1 21.58-3.858-9.603z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2043",
    style: {
      fill: "#ffea00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m739.412 412.999 17.723-11.341-5.746 3.814-17.465 10.87z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2045",
    style: {
      fill: "#83ff73",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m631.865 483.663 32.446-6.796.537-8.717-32.483 6.666z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2047",
    style: {
      fill: "#1fffd7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m429.065 536.966 2.115 6.876-3.63-22.134-2.298-7.97z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2049",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m510.082 654.258-2.846-4.577-11.537-3.713 2.069 4.322z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2051",
    style: {
      fill: "#00c4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m608.313 565.784 30.854-9.676-5.546-.235-31.174 9.654z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2053",
    style: {
      fill: "#56ffa0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m599.597 508.519 33.854-6.857-1.22-8.973-33.946 6.498z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2055",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m538.323 653.906-4.159-1.565-11.85 2.612 3.465 1.712z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2057",
    style: {
      fill: "#29ffce",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m571.712 533.879 32.992-7.8-2.948-8.52-33.208 7.275z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2059",
    style: {
      fill: "#eeff09",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m778.01 430.489 19.373-12.332-4.638-6.68-19.201 12.47z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2061",
    style: {
      fill: "#920000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m520.73 263.33-1.391 10.381 14.732 11.187-.097-10.075z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2063",
    style: {
      fill: "#0038ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m577.963 616.64-2.796 5.898-10.01 13.287 2.398-5.361z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2065",
    style: {
      fill: "#ffde00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m745.217 411.112 17.99-11.746-6.072 2.292-17.723 11.34z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2067",
    style: {
      fill: "#9aff5d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m761.666 474.415 26.284-9.928-1.146-9.234-26.261 10.178z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2069",
    style: {
      fill: "#0074ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m453.542 604.885.713-1.467-7.915-16.266-1.247.375z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2071",
    style: {
      fill: "#5aff9d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m728.699 509.39 30.885-8.683 1.593-8.422-30.998 8.826z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2073",
    style: {
      fill: "#00c4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m561.688 570.484 29.098-10.145-5.502-4.797-29.532 9.766z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2075",
    style: {
      fill: "#00d0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m555.752 565.308 29.532-9.766-5.096-6.115-29.942 9.284z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2077",
    style: {
      fill: "#d1ff26",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m417.24 441.809 3.771 13.408 2.838-23.049-3.704-14.143z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2079",
    style: {
      fill: "#e4ff13",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m705.342 429.797 23.555-8.749-4.436 5.942-23.316 8.351z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2081",
    style: {
      fill: "#df0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m546.476 290.168 1.494 9.84 12.676 18.61-2.759-9.682z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2083",
    style: {
      fill: "#29ffce",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m693.457 528.01 31.532-7.513-3.368 6.257-31.54 7.602z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2085",
    style: {
      fill: "#c4ff33",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m596.403 428.667 1.556 14.796 2.471 26.75-1.545-14.687z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2087",
    style: {
      fill: "#00bcff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m567.904 574.11 28.651-10.415-5.769-3.356-29.098 10.145z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2089",
    style: {
      fill: "#09f0ee",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m654.315 548 31.763-8.418-4.524 3.974-31.907 8.57z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2091",
    style: {
      fill: "#beff39",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m669.814 448.583 27.81-6.629-2.76 7.505-27.634 6.436z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2093",
    style: {
      fill: "#b20000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m533.974 274.823.097 10.075 13.9 15.11-1.495-9.84z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2095",
    style: {
      fill: "#0cf",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m614.005 564.457 30.55-9.607-5.388 1.258-30.854 9.676z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2097",
    style: {
      fill: "#00e0fb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m550.246 558.71 29.942-9.283-4.563-7.282-30.318 8.713z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2099",
    style: {
      fill: "#fbf100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m773.544 423.946 19.201-12.47-5.258-5.416-18.999 12.513z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2101",
    style: {
      fill: "#ff5200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m425.748 344.39 3.328 15.68 9.666-17.553-3.235-15.938z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2103",
    style: {
      fill: "#ffdb00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m751.185 410.734 18.259-12.072-6.237.704-17.99 11.746z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2105",
    style: {
      fill: "#ff9f00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m580.97 364.133 3.07 12.358 7.378 25.587-3.344-12.333z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2107",
    style: {
      fill: "#00d4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m436.744 565.226 1.406 3.292-5.255-20.202-1.715-4.474z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2109",
    style: {
      fill: "#0028ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m484.363 639.285-.217-6.37-10.092-8.813-.55 5.7z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2111",
    style: {
      fill: "#00b8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m574.244 576.093 28.203-10.566-5.892-1.832-28.651 10.415z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2113",
    style: {
      fill: "#9aff5d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m632.365 474.816 32.483-6.666 1.383-8.315-32.51 6.54z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2115",
    style: {
      fill: "#02e8f4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m599.26 535.381.38 12.38-4.837 22.537-.474-11.876z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2117",
    style: {
      fill: "#0040ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m473.504 629.801.55-5.699-9.403-11.203-1.266 4.85z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2119",
    style: {
      fill: "#6dff8a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m598.285 499.187 33.947-6.498-.367-9.026-34.009 6.138z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2121",
    style: {
      fill: "#40ffb7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m568.548 524.834 33.208-7.276-2.16-9.04-33.38 6.72z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2123",
    style: {
      fill: "#ffe600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m768.488 418.573 18.999-12.513-5.74-4.006-18.77 12.46z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2125",
    style: {
      fill: "gold",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m757.158 411.878 18.521-12.313-6.235-.903-18.259 12.072z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2127",
    style: {
      fill: "#00f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m522.315 654.953-3.622-4.628-11.457-.644 2.846 4.577z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2129",
    style: {
      fill: "#ffdb00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m762.978 414.514 18.77-12.46-6.069-2.489-18.52 12.313z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2131",
    style: {
      fill: "#0ff8e7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m545.307 550.858 30.318-8.713-3.913-8.266-30.652 8.065z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2133",
    style: {
      fill: "#0018ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m495.7 645.968-1.02-6.846-10.534-6.207.217 6.37z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2135",
    style: {
      fill: "#890000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m474.317 266.106-1.297 13.773 15.345-2.163.674-13.512z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2137",
    style: {
      fill: "#0018ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m565.157 635.825-4.18 2.326-10.821 9.541 3.642-1.856z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2139",
    style: {
      fill: "#b1ff46",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m760.543 465.431 26.261-10.178-2.077-8.898-26.193 10.375z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2141",
    style: {
      fill: "#f1fc06",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m710.104 425.472 23.82-9.13-5.027 4.706-23.555 8.75z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2143",
    style: {
      fill: "#0060ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m463.385 617.749 1.266-4.85-8.483-13.321-1.913 3.84z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2145",
    style: {
      fill: "#6dff8a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m730.179 501.111 30.998-8.826.701-8.84-31.066 8.935z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2147",
    style: {
      fill: "#00b8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m580.55 576.38 27.763-10.596-5.866-.257-28.203 10.566z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2149",
    style: {
      fill: "#94ff63",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m420.474 479.25 3.103 11.034.529-23.09-3.095-11.977z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2151",
    style: {
      fill: "#00d8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m619.38 561.574 30.267-9.449-5.093 2.725-30.549 9.607z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2153",
    style: {
      fill: "#00b4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m536.648 581.291 25.04-10.807-5.936-5.176-25.575 10.338z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2155",
    style: {
      fill: "#3cffba",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m696.117 520.699 31.537-7.407-2.665 7.205-31.532 7.512z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2157",
    style: {
      fill: "#16ffe1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m658.436 542.573 31.645-8.217-4.003 5.226L654.315 548z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2159",
    style: {
      fill: "#00c0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m530.177 575.646 25.575-10.338-5.506-6.597-26.08 9.744z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2161",
    style: {
      fill: "#00a8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m445.093 587.527 1.247-.375-6.502-17.81-1.688-.824z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2163",
    style: {
      fill: "#d1ff26",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m673.123 442.184 28.022-6.843-3.522 6.613-27.81 6.629z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2165",
    style: {
      fill: "#d10000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m445.288 297.109 1.857 15.04 13.223-10.618-1.837-15.115z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2167",
    style: {
      fill: "#00a8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m543.417 585.249 24.487-11.14-6.216-3.625-25.04 10.807z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2169",
    style: {
      fill: "#23ffd4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m541.06 541.944 30.652-8.065-3.164-9.045-30.934 7.357z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2171",
    style: {
      fill: "#0010ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m507.236 649.681-1.836-7.116-10.72-3.443 1.02 6.846z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2173",
    style: {
      fill: "#00d4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m524.166 568.455 26.08-9.744-4.94-7.853-26.54 9.04z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2175",
    style: {
      fill: "#56ffa0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m566.216 515.238 33.38-6.72-1.311-9.33-33.508 6.144z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2177",
    style: {
      fill: "#0008ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m550.156 647.692-4.82-1.227-11.172 5.876 4.16 1.565z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2179",
    style: {
      fill: "#83ff73",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m597.856 489.801 34.01-6.138.499-8.847-34.04 5.785z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2181",
    style: {
      fill: "#b1ff46",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m633.722 466.376 32.51-6.541 2.195-7.699-32.523 6.427z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2183",
    style: {
      fill: "#c4ff33",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m758.534 456.73 26.193-10.375-2.956-8.33-26.08 10.519z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2185",
    style: {
      fill: "#00a8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m550.315 587.419 23.93-11.326-6.341-1.983-24.487 11.139z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2187",
    style: {
      fill: "#feed00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "M715.31 422.483 739.412 413l-5.488 3.343-23.82 9.13z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2189",
    style: {
      fill: "#00a8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m594.803 570.298-1.298 9.799-6.811 19.621 1.092-9.18z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2191",
    style: {
      fill: "#00c0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m586.663 574.959 27.342-10.502-5.692 1.327-27.763 10.595z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2193",
    style: {
      fill: "#0040ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m484.146 632.915 2.06-8.403-9.309-8.128-2.843 7.718z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2195",
    style: {
      fill: "#08f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m454.255 603.418 1.913-3.84-7.352-15.119-2.476 2.693z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2197",
    style: {
      fill: "#5aff9d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m425.252 513.737 2.297 7.971-1.59-22.338-2.382-9.086z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2199",
    style: {
      fill: "#0058ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m474.054 624.102 2.843-7.718-8.671-10.336-3.575 6.851z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2201",
    style: {
      fill: "#ff9400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m421.498 380.463 3.875 15.408 7.444-19.924-3.741-15.876z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2203",
    style: {
      fill: "#06ecf1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m518.766 559.897 26.54-9.04-4.246-8.913-26.948 8.24z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2205",
    style: {
      fill: "#00a0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m516.509 592.506 20.14-11.215-6.472-5.645-20.762 10.67z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2207",
    style: {
      fill: "#02e8f4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "M624.297 557.203 654.315 548l-4.668 4.125-30.268 9.45z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2209",
    style: {
      fill: "#00b0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m509.415 586.316 20.762-10.67-6.01-7.19-21.349 9.978z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2211",
    style: {
      fill: "#83ff73",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m600.43 470.212 1.452 14.405-.071 25.95-1.447-14.062z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2213",
    style: {
      fill: "#0034ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m494.68 639.122 1.244-8.89-9.718-5.72-2.06 8.403z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2215",
    style: {
      fill: "#83ff73",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m730.812 492.38 31.066-8.935-.212-9.03-31.087 9.007z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2217",
    style: {
      fill: "#0008ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m534.164 652.341-4.378-4.472-11.093 2.456 3.622 4.628z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2219",
    style: {
      fill: "#39ffbe",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m537.614 532.19 30.934-7.356-2.333-9.596-31.157 6.604z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2221",
    style: {
      fill: "#ff6000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m571.747 340.198 2.708 12.424 9.586 23.869-3.07-12.358z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2223",
    style: {
      fill: "#0094ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m523.923 596.85 19.494-11.601-6.769-3.958-20.14 11.215z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2225",
    style: {
      fill: "#e1ff16",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m677.074 436.87 28.268-7.073-4.197 5.544-28.022 6.843z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2227",
    style: {
      fill: "#29ffce",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m661.903 535.978 31.554-7.969-3.376 6.347-31.645 8.217z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2229",
    style: {
      fill: "#53ffa4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m697.989 512.61 31.553-7.29-1.888 7.972-31.537 7.407z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2231",
    style: {
      fill: "#0074ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m464.651 612.9 3.575-6.852-7.821-12.292-4.237 5.822z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2233",
    style: {
      fill: "#00a8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m557.17 587.742 23.38-11.363-6.306-.286-23.929 11.326z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2235",
    style: {
      fill: "#d7ff1f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m755.69 448.544 26.08-10.518-3.76-7.537-25.925 10.6z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2237",
    style: {
      fill: "#00c4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m502.818 578.434 21.348-9.979-5.4-8.558-21.883 9.159z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2239",
    style: {
      fill: "#ffe600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m720.823 420.915 24.394-9.803-5.805 1.887-24.102 9.484z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2241",
    style: {
      fill: "#26ffd1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m431.18 543.842 1.715 4.474-3.426-20.903-1.92-5.705z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2243",
    style: {
      fill: "#0014ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m518.693 650.325-2.651-7.172-10.642-.588 1.836 7.116z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2245",
    style: {
      fill: "#6dff8a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m564.777 505.332 33.508-6.145-.429-9.386-33.584 5.566z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2247",
    style: {
      fill: "maroon",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m489.04 264.204-.675 13.512 15.781 2.304.04-13.266z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2249",
    style: {
      fill: "#005cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m486.206 624.512 5.493-9.902-8.534-7.45-6.268 9.224z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2251",
    style: {
      fill: "#008cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m501.589 603.766 14.92-11.26-7.094-6.19-15.614 10.653z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2253",
    style: {
      fill: "#0070ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m476.897 616.384 6.268-9.223-7.946-9.477-6.993 8.364z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2255",
    style: {
      fill: "#1cffdb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m514.112 550.183 26.948-8.24-3.446-9.752-27.291 7.364z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2257",
    style: {
      fill: "#009cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m493.801 596.969 15.614-10.653-6.597-7.882-16.265 9.884z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2259",
    style: {
      fill: "#0094ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m531.473 599.238 18.842-11.82-6.898-2.17-19.494 11.603z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2261",
    style: {
      fill: "#002cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m505.4 642.565.41-9.166-9.886-3.167-1.243 8.89z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2263",
    style: {
      fill: "#ffe600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m591.418 402.078 1.57 14.9 4.97 26.485-1.555-14.796z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2265",
    style: {
      fill: "#0cf",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m592.428 571.861 26.951-10.287-5.374 2.883-27.342 10.502z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2267",
    style: {
      fill: "#0070ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m586.694 599.718-3.135 6.558-8.392 16.262 2.796-5.899z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2269",
    style: {
      fill: "#9aff5d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m598.326 480.6 34.039-5.784 1.357-8.44-34.037 5.447z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2271",
    style: {
      fill: "#c4ff33",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m635.904 458.563 32.523-6.427 2.955-6.878-32.523 6.325z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2273",
    style: {
      fill: "#0074ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m491.699 614.61 9.89-10.844-7.788-6.797-10.636 10.192z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2275",
    style: {
      fill: "#0080ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m509.723 608.54 14.2-11.69-7.414-4.344-14.92 11.26z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2277",
    style: {
      fill: "#004cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m495.924 630.232 4.684-10.384-8.91-5.238-5.492 9.902z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2279",
    style: {
      fill: "#00e0fb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m438.15 568.518 1.688.824-4.919-18.921-2.024-2.105z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2281",
    style: {
      fill: "#e7ff0f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m752.085 441.09 25.925-10.601-4.466-6.543-25.733 10.62z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2283",
    style: {
      fill: "#0084ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m483.165 607.16 10.636-10.191-7.248-8.651-11.334 9.366z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2285",
    style: {
      fill: "#ffe200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m726.496 420.812 24.689-10.078-5.968.378-24.394 9.803z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2287",
    style: {
      fill: "#00e0fb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m496.883 569.056 21.883-9.159-4.654-9.714-22.353 8.229z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2289",
    style: {
      fill: "#00b4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m486.553 588.318 16.265-9.884-5.935-9.378-16.858 8.97z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2291",
    style: {
      fill: "#008cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m468.226 606.048 6.993-8.364-7.163-11.272-7.651 7.344z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2293",
    style: {
      fill: "#00b4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m446.34 587.152 2.476-2.693-6.035-16.55-2.943 1.433z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2295",
    style: {
      fill: "#0068ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m500.608 619.848 9.115-11.307-8.134-4.775-9.89 10.844z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2297",
    style: {
      fill: "#9aff5d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m730.579 483.422 31.087-9.007-1.123-8.984-31.061 9.041z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2299",
    style: {
      fill: "#009cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m456.168 599.578 4.237-5.822-6.775-13.95-4.814 4.653z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2301",
    style: {
      fill: "#13fce4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m628.63 551.45 29.806-8.877-4.121 5.427-30.018 9.203z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2303",
    style: {
      fill: "#00b0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m563.809 586.207 22.854-11.248-6.113 1.42-23.38 11.363z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2305",
    style: {
      fill: "#ffdb00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m420.145 418.025 3.704 14.143 5.093-21.458-3.569-14.839z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2307",
    style: {
      fill: "#53ffa4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m535.058 521.842 31.158-6.604-1.44-9.906-31.316 5.826z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2309",
    style: {
      fill: "#eeff09",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m681.565 432.787 28.54-7.315-4.763 4.325-28.268 7.074z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2311",
    style: {
      fill: "#f4f802",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m747.811 434.566 25.733-10.62-5.056-5.373-25.506 10.576z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2313",
    style: {
      fill: "#00a0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m475.22 597.684 11.333-9.366-6.528-10.292-11.969 8.386z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2315",
    style: {
      fill: "#ffe200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m732.181 422.18 24.977-10.302-5.973-1.144-24.689 10.078z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2317",
    style: {
      fill: "#007cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m518.002 611.172 13.47-11.934-7.55-2.387-14.2 11.69z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2319",
    style: {
      fill: "#0094ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m538.97 599.606 18.2-11.864-6.855-.323-18.842 11.82z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2321",
    style: {
      fill: "#04f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m575.167 622.538-4.66 2.951-9.53 12.662 4.18-2.326z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2323",
    style: {
      fill: "#ff1e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m435.507 326.58 3.235 15.937 11.524-14.211-3.121-16.156z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2325",
    style: {
      fill: "#66ff90",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m699.02 503.95 31.583-7.162-1.06 8.533-31.554 7.29z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2327",
    style: {
      fill: "#0048ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m505.81 633.399 3.864-10.657-9.066-2.894-4.684 10.384z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2329",
    style: {
      fill: "#feed00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m742.982 429.149 25.506-10.576-5.51-4.059-25.252 10.469z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2331",
    style: {
      fill: "#3cffba",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m664.623 528.38 31.494-7.681-2.66 7.31-31.554 7.969z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2333",
    style: {
      fill: "#ffe200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m737.726 424.983 25.252-10.469-5.82-2.636-24.977 10.301z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2335",
    style: {
      fill: "#36ffc1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m510.323 539.555 27.29-7.364-2.555-10.35-27.56 6.436z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2337",
    style: {
      fill: "#0064ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m509.674 622.742 8.328-11.57-8.28-2.631-9.114 11.307z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2339",
    style: {
      fill: "#00d0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m480.025 578.026 16.858-8.97-5.124-10.644-17.379 7.934z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2341",
    style: {
      fill: "#ff2900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m560.646 318.618 2.268 12.528 11.541 21.476-2.708-12.424z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2343",
    style: {
      fill: "#87ff70",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m564.272 495.367 33.584-5.566.47-9.2-33.608 4.997z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2345",
    style: {
      fill: "#0030ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m516.042 643.153-.418-9.225-9.813-.529-.41 9.166z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2347",
    style: {
      fill: "#13fce4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m491.759 558.412 22.353-8.229-3.79-10.628-22.746 7.21z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2349",
    style: {
      fill: "#43ffb4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m601.81 510.568.33 12.922-2.5 24.272-.38-12.38z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2351",
    style: {
      fill: "#00acff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m460.405 593.756 7.651-7.344-6.2-12.792-8.226 6.187z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2353",
    style: {
      fill: "#002cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m560.977 638.15-5.43-.705-10.21 9.02 4.819 1.227z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2355",
    style: {
      fill: "#a80000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m458.531 286.416 1.837 15.115 14.465-6.478-1.813-15.174z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2357",
    style: {
      fill: "#00dcfe",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m597.696 567.158 26.6-9.955-4.917 4.371-26.951 10.287z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2359",
    style: {
      fill: "maroon",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m504.187 266.754-.04 13.266 15.78 6.732-.588-13.04z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2361",
    style: {
      fill: "#0020ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m529.786 647.869-3.444-7.012-10.3 2.296 2.65 7.172z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2363",
    style: {
      fill: "#d7ff1f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m638.859 451.583 32.523-6.325 3.642-5.876-32.511 6.24z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2365",
    style: {
      fill: "#00c0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m468.056 586.412 11.969-8.386-5.645-11.68-12.524 7.274z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2367",
    style: {
      fill: "#0020ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m545.336 646.465-5.097-4.111-10.453 5.515 4.378 4.472z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2369",
    style: {
      fill: "#b1ff46",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m599.685 471.823 34.037-5.447 2.182-7.813-34 5.135z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2371",
    style: {
      fill: "#b1ff46",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m729.482 474.472 31.06-9.041-2.008-8.7-30.988 9.035z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2373",
    style: {
      fill: "#ceff29",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m421.011 455.217 3.095 11.978 2.742-22.133-2.999-12.894z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2375",
    style: {
      fill: "#007cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m526.22 611.59 12.75-11.984-7.497-.368-13.471 11.934z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2377",
    style: {
      fill: "#fbf100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m686.482 430.044 28.828-7.56-5.206 2.988-28.539 7.315z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2379",
    style: {
      fill: "#00bcff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m570.064 582.844 22.364-10.983-5.765 3.098-22.854 11.248z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2381",
    style: {
      fill: "#00c4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m448.816 584.46 4.814-4.653-5.557-15.268-5.292 3.37z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2383",
    style: {
      fill: "#009cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m546.228 597.937 17.58-11.73-6.638 1.535-18.2 11.864z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2385",
    style: {
      fill: "#6dff8a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m533.46 511.158 31.317-5.826-.505-9.965-31.407 5.041z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2387",
    style: {
      fill: "#004cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m515.624 633.928 3.047-10.714-8.997-.472-3.863 10.657z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2389",
    style: {
      fill: "#23ffd4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m632.267 544.455 29.636-8.477-3.467 6.595-29.805 8.877z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2391",
    style: {
      fill: "#0064ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m518.671 623.214 7.55-11.625-8.219-.417-8.328 11.57z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2393",
    style: {
      fill: "#09f0ee",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m474.38 566.346 17.379-7.934-4.183-11.647-17.813 6.8z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2395",
    style: {
      fill: "#df0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m547.97 300.009 1.758 12.667 13.186 18.47-2.268-12.528z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2397",
    style: {
      fill: "#7dff7a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m699.18 494.943 31.624-7.028-.201 8.873-31.583 7.163z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2399",
    style: {
      fill: "#02e8f4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m439.838 569.342 2.943-1.433-4.563-17.579-3.299.09z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2401",
    style: {
      fill: "#94ff63",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m423.577 490.284 2.383 9.086.512-21.981-2.366-10.194z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2403",
    style: {
      fill: "#920000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m519.339 273.711.588 13.04 15.337 10.987-1.193-12.84z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2405",
    style: {
      fill: "#50ffa7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m666.523 519.97 31.466-7.36-1.872 8.089-31.494 7.68z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2407",
    style: {
      fill: "#50ffa7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m507.497 528.277 27.56-6.435-1.597-10.684-27.75 5.473z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2409",
    style: {
      fill: "#30ffc7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m487.576 546.765 22.747-7.21-2.826-11.278-23.055 6.128z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2411",
    style: {
      fill: "#c4ff33",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m727.546 465.766 30.988-9.036-2.843-8.186-30.87 8.992z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2413",
    style: {
      fill: "#2cffca",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m432.895 548.316 2.024 2.105-3.203-19.571-2.247-3.437z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2415",
    style: {
      fill: "#00d4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m453.63 579.807 8.226-6.187-5.08-14-8.703 4.92z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2417",
    style: {
      fill: "#5aff9d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m427.55 521.708 1.919 5.705-1.496-21.087-2.013-6.956z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2419",
    style: {
      fill: "#b20000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m534.071 284.898 1.193 12.84 14.464 14.938-1.758-12.667z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2421",
    style: {
      fill: "#00e4f8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m461.856 573.62 12.524-7.274-4.617-12.78-12.987 6.055z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2423",
    style: {
      fill: "#ffea00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m691.694 428.72 29.129-7.805-5.513 1.568-28.828 7.561z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2425",
    style: {
      fill: "#9dff5a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m564.718 485.598 33.608-4.997 1.36-8.778-33.578 4.454z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2427",
    style: {
      fill: "#e7ff0f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m642.513 445.621 32.51-6.239 4.236-4.714-32.486 6.17z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2429",
    style: {
      fill: "#09f0ee",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m602.332 560.963 26.299-9.513-4.334 5.753-26.601 9.955z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2431",
    style: {
      fill: "#06ecf1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m599.64 547.762-1.443 10.488-4.692 21.847 1.298-9.8z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2433",
    style: {
      fill: "#003cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m526.342 640.857-1.221-9.061-9.497 2.132.418 9.225z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2435",
    style: {
      fill: "#08f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m534.174 609.774 12.054-11.837-7.257 1.669-12.75 11.983z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2437",
    style: {
      fill: "#c4ff33",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m597.959 443.463 1.485 14.748 2.438 26.406-1.452-14.405z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2439",
    style: {
      fill: "#ff9f00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m584.04 376.49 1.591 14.994 7.358 25.493-1.57-14.9z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2441",
    style: {
      fill: "#c7ff30",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m601.904 463.698 34-5.135 2.955-6.98-33.93 4.855z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2443",
    style: {
      fill: "#ff5900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m429.076 360.07 3.741 15.877 9.49-17.142-3.565-16.288z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2445",
    style: {
      fill: "#00d0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m575.775 577.73 21.92-10.572-5.267 4.703-22.364 10.983z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2447",
    style: {
      fill: "#d7ff1f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m724.822 457.536 30.869-8.992-3.606-7.455-30.707 8.91z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2449",
    style: {
      fill: "#00acff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m553.062 594.267 17.002-11.423-6.255 3.363-17.58 11.73z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2451",
    style: {
      fill: "#ffe600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m697.066 428.852 29.43-8.04-5.673.103-29.129 7.805z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2453",
    style: {
      fill: "#0070ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m527.378 621.242 6.796-11.468-7.953 1.815-7.55 11.625z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2455",
    style: {
      fill: "#0054ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m525.12 631.796 2.258-10.554-8.707 1.972-3.047 10.714z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2457",
    style: {
      fill: "#87ff70",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m532.865 500.409 31.407-5.042.446-9.769-31.425 4.27z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2459",
    style: {
      fill: "#94ff63",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m698.462 485.823 31.675-6.892.667 8.984-31.623 7.028z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2461",
    style: {
      fill: "#26ffd1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m469.763 553.566 17.813-6.8-3.134-12.361-18.15 5.594z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2463",
    style: {
      fill: "#39ffbe",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m635.11 536.393 29.513-8.013-2.72 7.598-29.636 8.477z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2465",
    style: {
      fill: "#0038ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m540.24 642.354-4.196-6.635-9.702 5.138 3.444 7.012z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2467",
    style: {
      fill: "#0cf4eb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m442.78 567.91 5.293-3.37-4.197-16.214-5.658 2.004z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2469",
    style: {
      fill: "#66ff90",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m667.548 510.965 31.472-7.014-1.031 8.66-31.466 7.36z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2471",
    style: {
      fill: "#00b0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m593.505 580.097-3.405 7.325-6.541 18.854 3.135-6.558z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2473",
    style: {
      fill: "#e4ff13",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m721.378 450 30.707-8.91-4.274-6.524-30.507 8.793z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2475",
    style: {
      fill: "#6aff8d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m505.71 516.631 27.75-5.473-.595-10.75-27.851 4.504z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2477",
    style: {
      fill: "#ffe600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m702.454 430.442 29.727-8.263-5.685-1.367-29.43 8.04z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2479",
    style: {
      fill: "#49ffad",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m484.442 534.405 23.055-6.128-1.786-11.646-23.268 5.008z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2481",
    style: {
      fill: "#f4f802",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m646.773 440.838 32.486-6.17 4.72-3.426-32.449 6.123z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2483",
    style: {
      fill: "#8d0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m473.02 279.879 1.813 15.174 15.318-2.12-1.786-15.217z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2485",
    style: {
      fill: "#0040ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m555.547 637.445-5.76-3.549-9.548 8.458 5.097 4.11z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2487",
    style: {
      fill: "#1fffd7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m456.776 559.62 12.987-6.054-3.471-13.567-13.345 4.76z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2489",
    style: {
      fill: "#16ffe1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m448.073 564.54 8.703-4.92-3.829-14.862-9.07 3.568z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2491",
    style: {
      fill: "#f1fc06",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m717.304 443.359 30.507-8.793-4.829-5.417-30.273 8.643z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2493",
    style: {
      fill: "#b4ff43",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m566.108 476.277 33.577-4.454 2.219-8.125-33.494 3.95z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2495",
    style: {
      fill: "#ffe600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m707.715 433.448 30.01-8.465-5.544-2.804-29.727 8.263z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2497",
    style: {
      fill: "#007cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m583.559 606.276-5.068 3.72-7.984 15.493 4.66-2.95z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2499",
    style: {
      fill: "#feed00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m712.71 437.792 30.272-8.643-5.256-4.166-30.011 8.465z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2501",
    style: {
      fill: "#1cffdb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m606.213 553.426 26.054-8.97-3.636 6.994-26.3 9.513z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2503",
    style: {
      fill: "#0054ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m570.507 625.49-5.974-.009-8.986 11.964 5.43.706z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2505",
    style: {
      fill: "#d60000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m447.145 312.15 3.121 16.156 13.09-10.447-2.988-16.328z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2507",
    style: {
      fill: "#0098ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m541.66 605.763 11.402-11.496-6.834 3.67-12.054 11.837z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2509",
    style: {
      fill: "#d7ff1f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m604.928 456.438 33.93-4.855 3.655-5.962-33.83 4.617z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2511",
    style: {
      fill: "#ff9c00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m425.373 395.871 3.57 14.839 7.243-19.29-3.369-15.473z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2513",
    style: {
      fill: "#30ffc7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m434.92 550.42 3.298-.09-2.967-18.176-3.535-1.304z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2515",
    style: {
      fill: "#aaff4d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m696.88 476.83 31.736-6.756 1.521 8.857-31.675 6.892z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2517",
    style: {
      fill: "#0050ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m536.044 635.72-1.982-8.68-8.941 4.756 1.221 9.061z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2519",
    style: {
      fill: "#00e4f8",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m580.794 570.99 21.538-10.027-4.636 6.195-21.92 10.573z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2521",
    style: {
      fill: "#00c0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m559.298 588.677 16.477-10.946-5.711 5.113-17.002 11.423z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2523",
    style: {
      fill: "#feed00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m651.53 437.365 32.448-6.123 5.081-2.04-32.399 6.095z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2525",
    style: {
      fill: "#a0ff56",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m533.293 489.869 31.425-4.271 1.39-9.32-31.37 3.533z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2527",
    style: {
      fill: "#50ffa7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m637.08 527.468 29.443-7.497-1.9 8.409-29.513 8.013z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2529",
    style: {
      fill: "#0080ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m535.573 616.866 6.087-11.103-7.486 4.011-6.796 11.468z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2531",
    style: {
      fill: "#46ffb1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m466.292 540 18.15-5.595-2-12.766-18.381 4.346z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2533",
    style: {
      fill: "#83ff73",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m601.882 484.617.33 13.488-.071 25.385-.33-12.922z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2535",
    style: {
      fill: "#7dff7a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m667.67 501.597 31.51-6.654-.16 9.008-31.471 7.014z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2537",
    style: {
      fill: "#0068ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m534.062 627.04 1.51-10.174-8.194 4.376-2.257 10.554z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2539",
    style: {
      fill: "#5dff9a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m429.469 527.413 2.247 3.437-1.394-19.735-2.349-4.79z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2541",
    style: {
      fill: "#ff6000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m574.455 352.622 1.614 15.076 9.562 23.787-1.59-14.994z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2543",
    style: {
      fill: "#ffe200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m423.85 432.168 2.998 12.894 4.913-20.595-2.819-13.757z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2545",
    style: {
      fill: "#87ff70",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m505.014 504.912 27.85-4.503.429-10.54-27.864 3.55z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2547",
    style: {
      fill: "#6aff8d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m482.443 521.64 23.268-5.009-.697-11.719-23.38 3.878z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2549",
    style: {
      fill: "#beff39",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m694.474 468.202 31.805-6.624 2.337 8.496-31.735 6.756z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2551",
    style: {
      fill: "#36ffc1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m438.218 550.33 5.658-2.004-2.721-16.758-5.904.586z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2553",
    style: {
      fill: "#caff2c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m568.41 467.647 33.494-3.949 3.024-7.26-33.358 3.499z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2555",
    style: {
      fill: "#e7ff0f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m608.682 450.238 33.83-4.617 4.261-4.783-33.701 4.426z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2557",
    style: {
      fill: "#90ff66",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m425.96 499.37 2.013 6.956.491-20.74-1.992-8.197z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2559",
    style: {
      fill: "#caff2c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m424.106 467.195 2.366 10.194 2.624-21.06-2.248-11.267z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2561",
    style: {
      fill: "#40ffb7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "M452.947 544.758 466.292 540l-2.231-14.014-13.588 3.416z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2563",
    style: {
      fill: "#ffe600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m656.66 435.297 32.4-6.096 5.309-.598-32.34 6.091z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2565",
    style: {
      fill: "#0054ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m549.788 633.896-4.888-6.048-8.856 7.871 4.195 6.635z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2567",
    style: {
      fill: "#33ffc4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m609.236 544.736 25.874-8.343-2.843 8.062-26.054 8.971z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2569",
    style: {
      fill: "#3cffba",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m443.876 548.326 9.071-3.568-2.474-15.357-9.318 2.167z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2571",
    style: {
      fill: "#00acff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m548.488 599.644 10.81-10.967-6.236 5.59-11.402 11.496z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2573",
    style: {
      fill: "maroon",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m488.365 277.716 1.786 15.217 15.753 2.328-1.758-15.24z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2575",
    style: {
      fill: "#ffea00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m592.989 416.977 1.544 15.087 4.91 26.147-1.484-14.748z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2577",
    style: {
      fill: "#d1ff26",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m691.305 460.168 31.88-6.5 3.094 7.91-31.805 6.624z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2579",
    style: {
      fill: "#94ff63",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m666.88 492.11 31.582-6.287.719 9.12-31.511 6.654z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2581",
    style: {
      fill: "#16ffe1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m584.989 562.784 21.224-9.358-3.881 7.537-21.538 10.026z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2583",
    style: {
      fill: "#00d8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m564.773 581.301 16.021-10.312-5.019 6.742-16.477 10.946z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2585",
    style: {
      fill: "#66ff90",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m638.123 517.907 29.425-6.942-1.025 9.006-29.443 7.497z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2587",
    style: {
      fill: "#ffe200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m662.029 434.694 32.34-6.091 5.397.864-32.272 6.109z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2589",
    style: {
      fill: "#b7ff40",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m534.738 479.81 31.37-3.533 2.302-8.63-31.242 2.85z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2591",
    style: {
      fill: "#43ffb4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m602.14 523.49-1.52 11.232-2.423 23.528 1.442-10.488z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2593",
    style: {
      fill: "#ff2500",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m438.742 342.517 3.565 16.288 11.308-13.867-3.349-16.632z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2595",
    style: {
      fill: "#66ff90",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m464.06 525.985 18.383-4.346-.81-12.849-18.5 3.085z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2597",
    style: {
      fill: "#0098ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m543.048 610.18 5.44-10.536-6.828 6.119-6.087 11.103z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2599",
    style: {
      fill: "#0068ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m564.533 625.482-6.35-2.798-8.395 11.212 5.76 3.55z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2601",
    style: {
      fill: "#e1ff16",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m687.455 452.944 31.958-6.389 3.771 7.112-31.879 6.501z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2603",
    style: {
      fill: "#f8f500",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m613.072 445.264 33.701-4.426 4.757-3.473-33.547 4.288z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2605",
    style: {
      fill: "#006cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m544.9 627.848-2.68-8.083-8.158 7.275 1.982 8.68z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2607",
    style: {
      fill: "#ff2900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m562.914 331.146 1.639 15.145 11.516 21.407-1.614-15.076z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2609",
    style: {
      fill: "#60ff97",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m431.716 530.85 3.535 1.304-1.285-18.32-3.644-2.72z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2611",
    style: {
      fill: "#ffe600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m667.494 435.576 32.272-6.11 5.343 2.306-32.199 6.149z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2613",
    style: {
      fill: "#deff19",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m571.57 459.937 33.358-3.499 3.754-6.2-33.173 3.112z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2615",
    style: {
      fill: "#a4ff53",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m505.429 493.42 27.864-3.551 1.445-10.058-27.786 2.637z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2617",
    style: {
      fill: "#0080ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m542.22 619.765.828-9.585-7.475 6.686-1.511 10.174z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2619",
    style: {
      fill: "#87ff70",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m481.633 508.79 23.38-3.878.416-11.493-23.388 2.766z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2621",
    style: {
      fill: "#eeff09",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m683.025 446.722 32.04-6.29 4.348 6.123-31.958 6.389z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2623",
    style: {
      fill: "#ffea00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m672.91 437.92 32.199-6.148 5.145 3.687-32.12 6.21z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2625",
    style: {
      fill: "#ad0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m460.368 301.531 2.988 16.328 14.316-6.358-2.84-16.448z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2627",
    style: {
      fill: "#fbf100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m678.134 441.67 32.12-6.21 4.81 4.971-32.039 6.29z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2629",
    style: {
      fill: "#0cf4eb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m598.197 558.25-3.597 8.182-4.5 20.99 3.405-7.325z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2631",
    style: {
      fill: "#aaff4d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m665.195 482.752 31.686-5.922 1.581 8.993-31.582 6.286z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2633",
    style: {
      fill: "#4dffaa",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m611.317 535.11 25.763-7.642-1.97 8.925-25.874 8.343z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2635",
    style: {
      fill: "#08f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m578.49 609.997-6.437.851-7.52 14.634 5.974.008z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2637",
    style: {
      fill: "maroon",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m504.146 280.02 1.758 15.24 15.75 6.737-1.727-15.245z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2639",
    style: {
      fill: "#66ff90",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m450.473 529.4 13.588-3.415-.929-14.11-13.708 2.058z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2641",
    style: {
      fill: "#00b8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m590.1 587.422-5.393 4.617-6.216 17.958 5.068-3.72z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2643",
    style: {
      fill: "#00c8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m554.482 591.562 10.29-10.26-5.474 7.375-10.81 10.967z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2645",
    style: {
      fill: "#7dff7a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m638.206 507.957 29.464-6.36-.122 9.368-29.425 6.942z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2647",
    style: {
      fill: "#60ff97",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m435.251 532.154 5.904-.586-1.17-16.884-6.019-.85z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2649",
    style: {
      fill: "#ffea00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m617.983 441.653 33.547-4.288 5.13-2.068-33.37 4.207z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2651",
    style: {
      fill: "#df0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m549.728 312.676 1.668 15.196 13.157 18.419-1.64-15.145z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2653",
    style: {
      fill: "#63ff94",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m441.155 531.568 9.318-2.167-1.05-15.468-9.437.75z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2655",
    style: {
      fill: "#90ff66",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m427.973 506.326 2.35 4.789.466-19.401-2.325-6.128z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2657",
    style: {
      fill: "#2cffca",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m588.247 553.316 20.989-8.58-3.023 8.69-21.224 9.358z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2659",
    style: {
      fill: "#d1ff26",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m537.168 470.497 31.242-2.85 3.16-7.71-31.044 2.236z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2661",
    style: {
      fill: "#ff6000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m432.817 375.947 3.369 15.474 9.228-16.585-3.107-16.03z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2663",
    style: {
      fill: "#0cf4eb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m569.344 572.317 15.645-9.533-4.195 8.205-16.021 10.312z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2665",
    style: {
      fill: "#920000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m519.927 286.752 1.728 15.245 15.307 10.97-1.698-15.23z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2667",
    style: {
      fill: "#eeff09",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m575.509 453.35 33.173-3.112 4.39-4.974-32.945 2.802z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2669",
    style: {
      fill: "#c1ff36",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m662.657 473.772 31.817-5.57 2.407 8.628-31.686 5.922z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2671",
    style: {
      fill: "#007cff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m558.183 622.684-5.502-5.263-7.781 10.427 4.888 6.048z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2673",
    style: {
      fill: "#b20000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m535.264 297.738 1.698 15.23 14.434 14.904-1.668-15.196z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2675",
    style: {
      fill: "#c1ff36",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m599.444 458.211.379 14.065 2.389 25.83-.33-13.49z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2677",
    style: {
      fill: "#8aff6d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m463.132 511.875 18.501-3.085.408-12.605-18.502 1.843z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2679",
    style: {
      fill: "#ffe200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m623.29 439.504 33.37-4.207 5.369-.603-33.178 4.186z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2681",
    style: {
      fill: "#beff39",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m506.952 482.448 27.786-2.637 2.43-9.314-27.617 1.79z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2683",
    style: {
      fill: "#00b4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m549.609 601.34 4.873-9.778-5.994 8.082-5.44 10.536z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2685",
    style: {
      fill: "#ffa300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m585.631 391.485 1.629 15.408 7.273 25.17-1.544-15.086z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2687",
    style: {
      fill: "#c7ff30",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m426.472 477.389 1.992 8.197 2.485-19.861-1.853-9.396z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2689",
    style: {
      fill: "#a7ff50",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m482.041 496.185 23.388-2.766 1.523-10.97-23.288 1.7z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2691",
    style: {
      fill: "#ffa300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m428.942 410.71 2.819 13.757 6.979-18.502-2.554-14.544z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2693",
    style: {
      fill: "#63ff94",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m612.399 524.795 25.724-6.888-1.043 9.56-25.763 7.643z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2695",
    style: {
      fill: "#97ff60",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m637.324 497.877 29.556-5.768.79 9.488-29.464 6.36z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2697",
    style: {
      fill: "#ffea00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m426.848 445.062 2.248 11.267 4.69-19.586-2.025-12.276z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2699",
    style: {
      fill: "#d4ff23",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m659.33 465.41 31.975-5.242 3.17 8.034-31.818 5.57z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2701",
    style: {
      fill: "#0090ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m552.681 617.421-3.299-7.284-7.163 9.628 2.681 8.083z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2703",
    style: {
      fill: "#00a0ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m549.382 610.137.227-8.796-6.561 8.84-.829 9.584z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2705",
    style: {
      fill: "#ffde00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m628.85 438.88 33.179-4.186 5.465.882-32.974 4.225z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2707",
    style: {
      fill: "#8dff6a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m430.322 511.115 3.644 2.719.444-18.002-3.62-4.118z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2709",
    style: {
      fill: "#e4ff13",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m540.526 462.173 31.044-2.236 3.939-6.587-30.78 1.711z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2711",
    style: {
      fill: "#feed00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m580.127 448.066 32.945-2.802 4.911-3.611-32.677 2.577z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2713",
    style: {
      fill: "#8aff6d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m449.424 513.933 13.708-2.058.407-13.847-13.703.72z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2715",
    style: {
      fill: "#02e8f4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m559.482 581.71 9.862-9.393-4.571 8.984-10.291 10.261z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2717",
    style: {
      fill: "#0098ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m572.053 610.848-6.85-1.871-7.02 13.707 6.35 2.798z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2719",
    style: {
      fill: "#46ffb1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m590.478 542.825 20.84-7.715-2.082 9.626-20.989 8.58z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2721",
    style: {
      fill: "#e4ff13",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m655.303 457.89 32.152-4.946 3.85 7.224-31.974 5.242z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2723",
    style: {
      fill: "#920000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m474.833 295.053 2.839 16.448 15.157-2.056-2.678-16.512z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2725",
    style: {
      fill: "#df0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m450.266 328.306 3.349 16.632 12.84-10.181-3.099-16.898z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2727",
    style: {
      fill: "#ffde00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m634.52 439.8 32.974-4.224 5.416 2.345-32.763 4.324z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2729",
    style: {
      fill: "#26ffd1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m572.886 561.944 15.361-8.628-3.258 9.468-15.645 9.533z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2731",
    style: {
      fill: "#83ff73",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m602.212 498.105-1.528 12.012-.064 24.605 1.52-11.232z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2733",
    style: {
      fill: "#f1fc06",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m650.679 451.411 32.346-4.69 4.43 6.223-32.152 4.945z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2735",
    style: {
      fill: "#ffe600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m640.147 442.245 32.763-4.324 5.224 3.748-32.552 4.48z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2737",
    style: {
      fill: "#8dff6a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m433.966 513.834 6.02.85.425-16.584-6-2.268z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2739",
    style: {
      fill: "#8dff6a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m439.986 514.684 9.438-.75.412-15.186-9.425-.648z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2741",
    style: {
      fill: "#adff49",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m635.495 487.934 29.7-5.182 1.685 9.357-29.556 5.768z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2743",
    style: {
      fill: "#feed00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m645.582 446.15 32.552-4.48 4.891 5.052-32.346 4.69z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2745",
    style: {
      fill: "#d7ff1f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m509.55 472.286 27.618-1.79 3.358-8.323-27.363 1.028z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2747",
    style: {
      fill: "#7dff7a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m612.446 514.057 25.76-6.1-.083 9.95-25.724 6.888z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2749",
    style: {
      fill: "#aaff4d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m463.54 498.028 18.501-1.843 1.623-12.037-18.384.652z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2751",
    style: {
      fill: "#00c4ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m584.707 592.039-6.806 1.854-5.848 16.955 6.438-.851z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2753",
    style: {
      fill: "#ffe200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m585.306 444.23 32.677-2.577 5.307-2.149-32.379 2.444z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2755",
    style: {
      fill: "#c4ff33",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m483.664 484.148 23.288-1.7 2.599-10.162-23.085.709z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2757",
    style: {
      fill: "#00d8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m555.083 590.556 4.4-8.846-5.001 9.852-4.873 9.779z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2759",
    style: {
      fill: "#46ffb1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m600.62 534.722-3.702 9.11-2.318 22.6 3.597-8.182z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2761",
    style: {
      fill: "#c1ff36",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m428.464 485.586 2.325 6.128 2.333-18.569-2.173-7.42z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2763",
    style: {
      fill: "#ff6400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m576.069 367.698 1.737 15.704 9.454 23.49-1.629-15.407z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2765",
    style: {
      fill: "#f8f500",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m544.728 455.061 30.781-1.71 4.618-5.285-30.458 1.289z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2767",
    style: {
      fill: "#00a8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m565.203 608.977-6.023-4.294-6.499 12.738 5.502 5.263z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2769",
    style: {
      fill: "#0ff8e7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m594.6 566.432-5.624 5.62-4.269 19.987 5.393-4.617z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2771",
    style: {
      fill: "#c4ff33",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m632.764 478.39 29.893-4.618 2.538 8.98-29.7 5.182z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2773",
    style: {
      fill: "#63ff94",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m591.62 531.577 20.779-6.782-1.082 10.315-20.839 7.715z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2775",
    style: {
      fill: "#ffea00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m594.533 432.064.478 14.633 4.812 25.579-.38-14.065z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2777",
    style: {
      fill: "#ff3000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m442.307 358.805 3.107 16.031 10.99-13.405-2.79-16.493z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2779",
    style: {
      fill: "#00c8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m555.36 598.381-.277-7.825-5.474 10.785-.227 8.796z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2781",
    style: {
      fill: "#ffdb00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m590.911 441.948 32.379-2.444 5.56-.624-32.055 2.406z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2783",
    style: {
      fill: "#00b8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m559.18 604.683-3.82-6.302-5.978 11.756 3.3 7.284z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2785",
    style: {
      fill: "#1cffdb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m563.354 570.33 9.532-8.386-3.542 10.373-9.862 9.393z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2787",
    style: {
      fill: "#adff49",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m449.836 498.748 13.703-.72 1.74-13.228-13.568-.564z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2789",
    style: {
      fill: "#840000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m490.151 292.933 2.678 16.512 15.585 2.332-2.51-16.516z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2791",
    style: {
      fill: "#97ff60",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m611.453 503.176 25.87-5.299.883 10.08-25.76 6.1z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2793",
    style: {
      fill: "#43ffb4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m575.303 550.444 15.175-7.619-2.231 10.491-15.36 8.628z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2795",
    style: {
      fill: "#fbf100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m429.096 456.329 1.853 9.396 4.435-18.46-1.598-10.522z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2797",
    style: {
      fill: "#d7ff1f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m629.201 469.502 30.13-4.092 3.326 8.362-29.893 4.619z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2799",
    style: {
      fill: "#eeff09",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m513.163 463.201 27.363-1.028 4.202-7.112-27.027.377z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2801",
    style: {
      fill: "#beff39",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m430.79 491.714 3.62 4.118 2.177-17.22-3.465-5.467z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2803",
    style: {
      fill: "#ffe600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m549.67 449.355 30.457-1.289 5.18-3.836-30.085.981z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2805",
    style: {
      fill: "gold",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m596.795 441.286 32.056-2.406 5.67.92-31.719 2.467z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2807",
    style: {
      fill: "#ff6c00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m436.186 391.42 2.554 14.545 8.885-15.897-2.211-15.232z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2809",
    style: {
      fill: "#caff2c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m465.28 484.8 18.384-.652 2.802-11.153-18.148-.456z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2811",
    style: {
      fill: "#b4ff43",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m440.411 498.1 9.425.648 1.875-14.512-9.279-1.991z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2813",
    style: {
      fill: "#ffae00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m431.76 424.467 2.026 12.276 6.657-17.585-1.703-13.193z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2815",
    style: {
      fill: "#deff19",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m486.466 472.995 23.085-.709 3.612-9.085-22.779-.18z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2817",
    style: {
      fill: "#ff2d00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m564.553 346.29 1.866 15.965 11.387 21.147-1.737-15.704z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2819",
    style: {
      fill: "#ebff0c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m624.899 461.506 30.404-3.617 4.028 7.521-30.13 4.092z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2821",
    style: {
      fill: "#0cf",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m577.9 593.893-7.247-.79-5.45 15.874 6.85 1.871z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2823",
    style: {
      fill: "#b00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m463.356 317.859 3.099 16.898 14.038-6.18-2.821-17.076z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2825",
    style: {
      fill: "#b7ff40",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m434.41 495.832 6.001 2.268 2.021-15.855-5.845-3.634z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2827",
    style: {
      fill: "gold",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m602.802 442.267 31.718-2.466 5.627 2.444-31.375 2.623z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2829",
    style: {
      fill: "#7dff7a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m591.633 519.863 20.813-5.806-.047 10.738-20.78 6.782z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2831",
    style: {
      fill: "#b1ff46",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m609.441 492.439 26.054-4.505 1.829 9.943-25.871 5.299z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2833",
    style: {
      fill: "#16ffe1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m559.32 578.09 4.034-7.76-3.872 11.38-4.4 8.846z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2835",
    style: {
      fill: "#f8f500",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m619.97 454.617 30.709-3.206 4.624 6.478-30.404 3.617z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2837",
    style: {
      fill: "#ffdb00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m608.772 444.868 31.375-2.623 5.435 3.905-31.035 2.871z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2839",
    style: {
      fill: "#890000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m505.904 295.26 2.51 16.517 15.58 6.682-2.34-16.462z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2841",
    style: {
      fill: "#ffe600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m614.547 449.021 31.035-2.871 5.097 5.261-30.709 3.206z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2843",
    style: {
      fill: "#c1ff36",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m599.823 472.276-1.464 12.806 2.325 25.035 1.528-12.012z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2845",
    style: {
      fill: "gold",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m555.222 445.211 30.084-.981 5.605-2.282-29.67.798z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2847",
    style: {
      fill: "#ffea00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m517.701 455.438 27.027-.377 4.941-5.706-26.619-.149z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2849",
    style: {
      fill: "#60ff97",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m576.524 538.108 15.095-6.53-1.14 11.247-15.176 7.62z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2851",
    style: {
      fill: "#3cffba",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m565.99 557.703 9.313-7.259-2.417 11.5-9.532 8.385z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2853",
    style: {
      fill: "#e40000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m551.396 327.872 2.013 16.182 13.01 18.2-1.866-15.963z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2855",
    style: {
      fill: "#00d8ff",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m570.653 593.103-6.434-3.165-5.039 14.745 6.023 4.294z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2857",
    style: {
      fill: "#16ffe1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m588.976 572.053-7.07 2.977-4.005 18.863 6.806-1.854z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2859",
    style: {
      fill: "#0cf4eb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m559.99 584.783-.67-6.693-4.237 12.466.278 7.825z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2861",
    style: {
      fill: "#d1ff26",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m451.71 484.236 13.57.564 3.038-12.261-13.308-1.762z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2863",
    style: {
      fill: "#9b0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m521.655 301.997 2.34 16.462 15.14 10.858-2.173-16.35z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2865",
    style: {
      fill: "#f4f802",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m430.949 465.725 2.173 7.42 4.157-17.249-1.895-8.631z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2867",
    style: {
      fill: "#c7ff30",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m606.46 482.13 26.304-3.74 2.73 9.544-26.053 4.505z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2869",
    style: {
      fill: "#ffa700",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m587.26 406.893.626 15.178 7.125 24.626-.478-14.633z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2871",
    style: {
      fill: "#b00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m536.962 312.968 2.172 16.349 14.275 14.737-2.013-16.182z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2873",
    style: {
      fill: "#02e8f4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m564.22 589.938-4.23-5.155-4.63 13.598 3.82 6.302z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2875",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m600.684 510.117-3.719 10.083-.047 23.631 3.702-9.11z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2877",
    style: {
      fill: "#f8f500",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m490.384 463.02 22.78.181 4.537-7.763-22.38-.945z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2879",
    style: {
      fill: "#9aff5d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m590.514 507.989 20.939-4.813.993 10.881-20.813 5.806z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2881",
    style: {
      fill: "#49ffad",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m596.918 543.831-5.755 6.708-2.187 21.514 5.624-5.621z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2883",
    style: {
      fill: "#ffd000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m561.241 442.746 29.67-.798 5.884-.662-29.225.746z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2885",
    style: {
      fill: "#e7ff0f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m468.318 472.539 18.148.456 3.918-9.974-17.8-1.453z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2887",
    style: {
      fill: "#f10800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m453.615 344.938 2.79 16.493 12.474-9.83-2.424-16.844z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2889",
    style: {
      fill: "#dbff1c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m442.432 482.245 9.279 1.99 3.299-13.458-9-3.245z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2891",
    style: {
      fill: "#deff19",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m602.585 472.527 26.616-3.025 3.563 8.889-26.304 3.74z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2893",
    style: {
      fill: "gold",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m523.05 449.206 26.62.149 5.552-4.144-26.149-.53z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2895",
    style: {
      fill: "#ebff0c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m433.122 473.145 3.465 5.466 3.868-15.988-3.176-6.727z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2897",
    style: {
      fill: "#9f0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m477.672 311.501 2.82 17.075 14.86-1.974-2.523-17.157z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2899",
    style: {
      fill: "#36ffc1",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m562.202 564.252 3.787-6.549-2.635 12.626-4.034 7.761z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2901",
    style: {
      fill: "#ffb900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m433.786 436.743 1.598 10.522 6.29-16.564-1.23-11.543z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2903",
    style: {
      fill: "#fc0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m567.57 442.032 29.225-.746 6.007.981-28.761.826z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2905",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m576.51 525.255 15.123-5.392-.014 11.714-15.095 6.531z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2907",
    style: {
      fill: "#e1ff16",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m436.587 478.611 5.845 3.634 3.579-14.713-5.556-4.909z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2909",
    style: {
      fill: "#f1fc06",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m597.917 463.886 26.982-2.38 4.302 7.996-26.616 3.025z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2911",
    style: {
      fill: "#5dff9a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m567.31 544.152 9.214-6.044-1.22 12.336-9.315 7.259z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2913",
    style: {
      fill: "#ff3b00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m445.414 374.836 2.211 15.232 10.577-12.838-1.798-15.8z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2915",
    style: {
      fill: "#1cffdb",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m581.907 575.03-7.53.42-3.724 17.653 7.248.79z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2917",
    style: {
      fill: "#b7ff40",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m588.285 496.267 21.156-3.828 2.012 10.737-20.94 4.813z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2919",
    style: {
      fill: "#fc0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m574.04 443.093 28.762-.826 5.97 2.601-28.293 1.036z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2921",
    style: {
      fill: "#ff7a00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m438.74 405.965 1.703 13.193 8.472-15.098-1.29-13.992z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2923",
    style: {
      fill: "#ffea00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m592.58 456.442 27.39-1.825 4.929 6.889-26.982 2.38z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2925",
    style: {
      fill: "#ffdb00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m495.321 454.493 22.38.945 5.349-6.232-21.896-1.56z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2927",
    style: {
      fill: "#ffd000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m580.48 445.904 28.292-1.036 5.775 4.153-27.832 1.373z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2929",
    style: {
      fill: "#f4f802",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m455.01 470.777 13.308 1.762 4.266-10.971-12.925-2.84z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2931",
    style: {
      fill: "#ffdb00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m586.715 450.394 27.832-1.373 5.423 5.596-27.39 1.825z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2933",
    style: {
      fill: "#ffc800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m529.073 444.68 26.149.531 6.02-2.465-25.628-.76z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2935",
    style: {
      fill: "#ff6c00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m577.806 383.402.817 15.683 9.263 22.986-.626-15.178z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2937",
    style: {
      fill: "#fbf100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m595.011 446.697-1.328 13.593 4.676 24.792 1.464-12.806z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2939",
    style: {
      fill: "#30ffc7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m563.142 569.68-.94-5.428-2.882 13.838.67 6.693z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2941",
    style: {
      fill: "#ffe600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m472.584 461.568 17.8 1.453 4.937-8.528-17.346-2.308z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2943",
    style: {
      fill: "#23ffd4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m574.377 575.45-6.722-1.899-3.436 16.387 6.434 3.165z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2945",
    style: {
      fill: "#29ffce",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m567.655 573.551-4.513-3.871-3.151 15.103 4.228 5.155z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2947",
    style: {
      fill: "#d1ff26",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m585 485.01 21.46-2.88 2.981 10.309-21.156 3.828z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2949",
    style: {
      fill: "#9dff5a",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m575.251 512.22 15.263-4.231 1.119 11.874-15.124 5.392z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2951",
    style: {
      fill: "#ffc400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m435.384 447.265 1.895 8.631 5.892-15.467-1.497-9.728z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2953",
    style: {
      fill: "#4dffaa",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m591.163 550.539-7.216 4.193-2.04 20.298 7.069-2.977z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2955",
    style: {
      fill: "#920000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m492.829 309.445 2.523 17.157 15.276 2.317-2.214-17.142z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2957",
    style: {
      fill: "#ffc100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m535.614 441.987 25.627.76 6.33-.715-25.071-.826z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2959",
    style: {
      fill: "#feed00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m446.01 467.532 9 3.245 4.649-12.048-8.592-4.373z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2961",
    style: {
      fill: "#5aff9d",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m563.643 549.392 3.667-5.24-1.32 13.551-3.788 6.549z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2963",
    style: {
      fill: "#c80000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m466.455 334.757 2.424 16.844 13.634-5.952-2.02-17.073z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2965",
    style: {
      fill: "#beff39",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m598.359 485.082-3.642 11.077 2.248 24.04 3.719-10.082z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2967",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m567.273 530.026 9.236-4.77.015 12.852-9.214 6.044z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2969",
    style: {
      fill: "#ffc800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m501.154 447.647 21.896 1.56 6.023-4.527-21.339-2.009z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2971",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m596.965 520.2-5.777 7.85-.025 22.489 5.755-6.708z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2973",
    style: {
      fill: "#e7ff0f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m580.746 474.522 21.839-1.995 3.875 9.603-21.46 2.88z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2975",
    style: {
      fill: "#ffd300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m437.28 455.896 3.175 6.727 5.474-14.327-2.758-7.867z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2977",
    style: {
      fill: "#ff3400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m566.42 362.255 1.047 16.134 11.156 20.696-.817-15.683z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2979",
    style: {
      fill: "#ffde00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m440.455 462.623 5.556 4.91 5.056-13.178-5.138-6.06z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2981",
    style: {
      fill: "#ffb900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m542.5 441.206 25.07.826 6.47 1.061-24.492-.729z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2983",
    style: {
      fill: "gold",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m459.659 458.729 12.925 2.839 5.39-9.383-12.428-3.766z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2985",
    style: {
      fill: "#fc0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m477.975 452.185 17.346 2.308 5.833-6.846-16.798-3z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2987",
    style: {
      fill: "#ff8600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m440.443 419.158 1.231 11.543 8-14.21-.759-12.431z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2989",
    style: {
      fill: "#baff3c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m572.778 499.349 15.507-3.082 2.229 11.722-15.263 4.232z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2991",
    style: {
      fill: "#960000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m508.414 311.777 2.214 17.142 15.27 6.567-1.904-17.027z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2993",
    style: {
      fill: "#fbf100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m575.63 465.083 22.287-1.197 4.668 8.64-21.84 1.996z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2995",
    style: {
      fill: "#56ffa0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m564.72 553.452-1.077-4.06-1.441 14.86.94 5.428z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2997",
    style: {
      fill: "#4dffaa",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m583.947 554.732-7.686 1.733-1.884 18.986 7.53-.421z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2999",
    style: {
      fill: "#ff1300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m456.404 361.43 1.798 15.8 12.002-9.403-1.325-16.226z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3001",
    style: {
      fill: "#ffbd00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m549.548 442.364 24.493.729 6.438 2.811-23.909-.469z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3003",
    style: {
      fill: "#ffae00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m587.886 422.07-1.123 14.352 6.92 23.868 1.328-13.593z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3005",
    style: {
      fill: "#f10800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m553.409 344.054 1.311 16.516 12.747 17.819-1.048-16.134z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3007",
    style: {
      fill: "#ffb900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m507.734 442.671 21.34 2.01 6.54-2.694-20.725-2.278z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3009",
    style: {
      fill: "#ffdb00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m569.789 456.949 22.79-.507 5.338 7.444-22.287 1.197z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3011",
    style: {
      fill: "#ff4a00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m447.625 390.068 1.29 13.992 10.08-12.183-.793-14.647z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3013",
    style: {
      fill: "#ffc100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m556.57 445.435 23.91.47 6.235 4.489-23.337-.053z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3015",
    style: {
      fill: "#fc0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m563.378 450.34 23.337.054 5.865 6.048-22.791.507z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3017",
    style: {
      fill: "#a40000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m523.994 318.459 1.904 17.027 14.835 10.647-1.599-16.816z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3019",
    style: {
      fill: "#a0ff56",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m565.87 515.694 9.381-3.473 1.258 13.034-9.236 4.771z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3021",
    style: {
      fill: "#c40000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m539.134 329.317 1.6 16.816 13.986 14.437-1.311-16.516z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3023",
    style: {
      fill: "#53ffa4",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m569.382 555.935-4.662-2.483-1.578 16.228 4.513 3.871z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3025",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m563.593 533.893 3.68-3.867.037 14.126-3.667 5.24z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3027",
    style: {
      fill: "#50ffa7",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m576.26 556.465-6.878-.53-1.727 17.616 6.722 1.9z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3029",
    style: {
      fill: "#d7ff1f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "M569.148 486.984 585 485.011l3.284 11.256-15.507 3.082z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3031",
    style: {
      fill: "#ffc800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m451.067 454.356 8.592 4.373 5.887-10.31-8.066-5.346z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3033",
    style: {
      fill: "#ad0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m480.493 328.576 2.02 17.073 14.428-1.876-1.589-17.17z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3035",
    style: {
      fill: "#ff9800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m441.674 430.701 1.497 9.728 7.487-13.26-.984-10.678z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3037",
    style: {
      fill: "#ffb600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m484.356 444.647 16.798 3 6.58-4.976-16.17-3.504z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3039",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m591.188 528.05-7.242 5.472v21.21l7.217-4.193z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3041",
    style: {
      fill: "#ffae00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m514.889 439.709 20.725 2.278 6.886-.781-20.07-2.358z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3043",
    style: {
      fill: "#ffb900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m465.546 448.42 12.429 3.765 6.38-7.538-11.83-4.514z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3045",
    style: {
      fill: "#f8f500",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m593.683 460.29-3.473 12.064 4.507 23.805 3.642-11.077z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3047",
    style: {
      fill: "#ffb600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m445.93 448.296 5.137 6.06 6.413-11.283-4.599-7.053z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3049",
    style: {
      fill: "#ffa700",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m443.17 440.43 2.76 7.866 6.951-12.276-2.223-8.852z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3051",
    style: {
      fill: "#baff3c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m594.717 496.159-5.69 9.016 2.161 22.874 5.777-7.85z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3053",
    style: {
      fill: "#f1fc06",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m564.454 475.46 16.292-.938L585 485.01l-15.853 1.973z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3055",
    style: {
      fill: "#c1ff36",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m563.132 501.536 9.646-2.187 2.473 12.872-9.38 3.473z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3057",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m564.669 536.517-1.076-2.624.05 15.499 1.077 4.06z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3059",
    style: {
      fill: "#ff7300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m578.623 399.085-.853 15.056 8.993 22.28 1.123-14.35z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3061",
    style: {
      fill: "#ffa700",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m522.43 438.848 20.07 2.358 7.048 1.158-19.39-2.245z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3063",
    style: {
      fill: "#ff5d00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m448.915 404.06.76 12.43 9.514-11.456-.194-13.157z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3065",
    style: {
      fill: "#a4ff53",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m562.045 518.16 3.826-2.466 1.402 14.332-3.68 3.867z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3067",
    style: {
      fill: "#da0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m468.879 351.6 1.325 16.227 13.112-5.677-.803-16.5z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3069",
    style: {
      fill: "#ffe200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m558.818 465.086 16.812-.004 5.116 9.44-16.292.937z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3071",
    style: {
      fill: "#ffa300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m491.564 439.167 16.17 3.504 7.155-2.962-15.477-3.808z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3073",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m583.946 533.522-7.71 3.111.025 19.832 7.686-1.733z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3075",
    style: {
      fill: "#a40000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m495.352 326.602 1.59 17.171 14.83 2.279-1.144-17.133z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3077",
    style: {
      fill: "#ffab00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m530.159 440.119 19.39 2.245 7.021 3.071-18.705-1.942z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3079",
    style: {
      fill: "#ffa700",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m457.48 443.073 8.066 5.346 6.98-8.286-7.435-6.135z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3081",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m569.34 537.542-4.671-1.025.05 16.935 4.663 2.483z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3083",
    style: {
      fill: "#ff2500",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m458.202 377.23.793 14.647 11.433-8.91-.224-15.14z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3085",
    style: {
      fill: "#fc0",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m552.39 456.147 17.399.802 5.84 8.134-16.81.004z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3087",
    style: {
      fill: "#ffae00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m537.865 443.493 18.705 1.942 6.808 4.906-18.035-1.457z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3089",
    style: {
      fill: "#80ff77",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m576.237 536.633-6.897.91.042 18.392 6.879.53z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3091",
    style: {
      fill: "#ff9f00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m472.525 440.133 11.83 4.514 7.21-5.48-11.146-5.064z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3093",
    style: {
      fill: "#ffbd00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m545.343 448.884 18.035 1.457 6.41 6.608-17.397-.802z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3095",
    style: {
      fill: "#e1ff16",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m559.121 487.93 10.027-.946 3.63 12.365-9.646 2.187z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3097",
    style: {
      fill: "#ff3f00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m567.467 378.389-.527 15.687 10.83 20.065.853-15.056z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3099",
    style: {
      fill: "#ff6f00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m449.674 416.49.984 10.678 8.9-10.682-.37-11.452z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3101",
    style: {
      fill: "#ffb600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m586.763 436.422-3.216 13.015 6.663 22.917 3.473-12.064z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3103",
    style: {
      fill: "#ff9800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m499.412 435.9 15.477 3.809 7.542-.861-14.738-3.9z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3105",
    style: {
      fill: "#ff9400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m452.881 436.02 4.599 7.053 7.611-9.075-3.951-7.858z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3107",
    style: {
      fill: "#b7ff40",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m589.028 505.175-7.142 6.78 2.06 21.567 7.242-5.473z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3109",
    style: {
      fill: "#a40000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m510.628 328.919 1.143 17.133 14.822 6.393-.695-16.96z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3111",
    style: {
      fill: "#a7ff50",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m562.978 519.32-.933-1.16 1.548 15.733 1.076 2.624z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3113",
    style: {
      fill: "#c7ff30",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m559.028 502.612 4.104-1.076 2.739 14.158-3.826 2.466z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3115",
    style: {
      fill: "#ff8200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m450.658 427.168 2.223 8.852 8.259-9.88-1.582-9.654z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3117",
    style: {
      fill: "#f1fc06",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m590.21 472.354-5.49 10.177 4.308 22.644 5.689-9.016z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3119",
    style: {
      fill: "#fbf100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m553.942 475.246 10.512.213 4.694 11.525-10.026.947z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3121",
    style: {
      fill: "#ff1300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m554.72 360.57-.153 16.225 12.373 17.281.527-15.687z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3123",
    style: {
      fill: "#c40000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m482.513 345.65.803 16.5 13.873-1.767-.248-16.61z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3125",
    style: {
      fill: "#b60000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m525.898 335.486.695 16.959 14.4 10.342-.26-16.654z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3127",
    style: {
      fill: "#ff9400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m507.693 434.948 14.738 3.9 7.728 1.27-13.974-3.775z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3129",
    style: {
      fill: "#ff8d00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m480.419 434.103 11.145 5.064 7.848-3.266-10.391-5.395z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3131",
    style: {
      fill: "#ff8d00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m465.091 433.998 7.434 6.135 7.894-6.03-6.712-6.713z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3133",
    style: {
      fill: "#d10000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m540.733 346.133.26 16.654 13.574 14.008.153-16.225z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3135",
    style: {
      fill: "#ff3800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m458.995 391.877.194 13.157 10.787-8.37.452-13.697z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3137",
    style: {
      fill: "#adff49",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m567.515 518.855-4.537.464 1.69 17.198 4.672 1.025z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3139",
    style: {
      fill: "#b4ff43",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m581.886 511.955-7.598 4.52 1.949 20.158 7.71-3.111z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3141",
    style: {
      fill: "#ffd300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m547.73 463.827 11.088 1.26 5.636 10.372-10.512-.213z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3143",
    style: {
      fill: "#f10800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m470.204 367.827.224 15.14 12.487-5.367.401-15.45z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3145",
    style: {
      fill: "#ff9400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m516.184 436.343 13.975 3.776 7.706 3.374-13.206-3.438z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3147",
    style: {
      fill: "#b1ff46",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m574.288 516.476-6.773 2.38 1.825 18.686 6.897-.909z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3149",
    style: {
      fill: "#ebff0c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m554.615 487.666 4.506.265 4.01 13.605-4.103 1.076z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3151",
    style: {
      fill: "#ff7e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m577.77 414.141-2.875 13.903 8.652 21.393 3.216-13.015z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3153",
    style: {
      fill: "#ffb900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m540.648 453.985 11.743 2.162 6.427 8.94-11.088-1.26z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3155",
    style: {
      fill: "#ff9c00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m524.66 440.055 13.205 3.438 7.478 5.39-12.455-2.894z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3157",
    style: {
      fill: "#ceff29",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m559.68 502.316-.652.296 3.017 15.548.933 1.16z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3159",
    style: {
      fill: "#ffa700",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m532.888 445.989 12.455 2.895 7.048 7.263-11.743-2.162z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3161",
    style: {
      fill: "#f70",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m461.14 426.14 3.951 7.858 8.616-6.608-3.213-8.452z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3163",
    style: {
      fill: "#ff8200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m489.02 430.506 10.392 5.395 8.28-.953-9.589-5.497z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3165",
    style: {
      fill: "#ff4a00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m459.189 405.034.369 11.452 10.086-7.794.332-12.028z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3167",
    style: {
      fill: "#b60000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m496.941 343.773.248 16.61 14.257 2.22.325-16.551z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3169",
    style: {
      fill: "#ebff0c",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m584.72 482.53-6.918 8.08 4.084 21.345 7.142-6.78z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3171",
    style: {
      fill: "#ff6000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m459.558 416.486 1.582 9.654 9.354-7.202-.85-10.246z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3173",
    style: {
      fill: "#f70",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m473.707 427.39 6.712 6.713 8.602-3.597-5.918-7.064z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3175",
    style: {
      fill: "#ffc100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m583.547 449.437-5.186 11.296 6.358 21.798 5.491-10.177z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3177",
    style: {
      fill: "#ffe200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m548.919 473.728 5.023 1.518 5.18 12.685-4.507-.265z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3179",
    style: {
      fill: "#d7ff1f",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m563.941 500.373-4.26 1.943 3.297 17.004 4.537-.465z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3181",
    style: {
      fill: "#ff4a00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m566.94 394.076-2.46 14.7 10.415 19.268 2.875-13.903z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3183",
    style: {
      fill: "#ff7a00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m498.103 429.45 9.59 5.498 8.492 1.395-8.76-5.365z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3185",
    style: {
      fill: "#ff1a00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m470.428 382.967-.452 13.697 11.779-5.029 1.16-14.035z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3187",
    style: {
      fill: "#da0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m483.316 362.15-.4 15.45 13.209-1.65 1.064-15.567z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3189",
    style: {
      fill: "#f4f802",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m554.854 485.966-.239 1.7 4.413 14.946.652-.296z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3191",
    style: {
      fill: "#e4ff13",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m577.802 490.61-7.352 5.921 3.838 19.945 7.598-4.521z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3193",
    style: {
      fill: "#b00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m511.771 346.052-.325 16.55 14.248 6.163.899-16.32z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3195",
    style: {
      fill: "#ffc100",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m542.087 461.178 5.643 2.649 6.212 11.419-5.023-1.518z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3197",
    style: {
      fill: "#deff19",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m570.45 496.531-6.509 3.842 3.574 18.482 6.773-2.38z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3199",
    style: {
      fill: "#ff6000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m470.494 418.938 3.213 8.452 9.396-3.948-2.402-8.814z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3201",
    style: {
      fill: "#ff7e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m507.424 430.978 8.76 5.365 8.475 3.712-7.927-5.002z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3203",
    style: {
      fill: "#ff6c00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m483.103 423.442 5.918 7.064 9.082-1.055-5.073-7.175z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3205",
    style: {
      fill: "#ff1e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m554.567 376.795-1.982 15.381 11.896 16.6 2.46-14.7z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3207",
    style: {
      fill: "#ffa700",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m534.301 450.36 6.347 3.625 7.082 9.842-5.643-2.649z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3209",
    style: {
      fill: "#c80000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m526.593 352.445-.9 16.32 13.842 9.949 1.457-15.927z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3211",
    style: {
      fill: "#ff8600",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m516.732 435.053 7.927 5.002 8.23 5.934-7.117-4.416z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3213",
    style: {
      fill: "#ff3000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m469.976 396.664-.332 12.028 11.01-4.674 1.1-12.383z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3215",
    style: {
      fill: "#ff8900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m574.895 428.044-4.782 12.341 8.248 20.348 5.186-11.296z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3217",
    style: {
      fill: "#ff9400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m525.772 441.573 7.116 4.416 7.76 7.996-6.347-3.624z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3219",
    style: {
      fill: "#e40000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m540.992 362.787-1.457 15.927 13.05 13.462 1.982-15.38z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3221",
    style: {
      fill: "#ffc800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m578.361 460.733-6.573 9.333 6.014 20.543 6.917-8.078z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3223",
    style: {
      fill: "#ff4a00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m469.644 408.692.85 10.246 10.207-4.31-.047-10.61z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3225",
    style: {
      fill: "#ffd300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m548.622 470.715.297 3.013 5.696 13.938.24-1.7z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3227",
    style: {
      fill: "#feed00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m558.703 482.594-3.849 3.372 4.826 16.35 4.261-1.943z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3229",
    style: {
      fill: "#cd0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m497.19 360.383-1.065 15.567 13.572 2.138 1.75-15.486z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3231",
    style: {
      fill: "#ff6400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m493.03 422.276 5.073 7.175 9.321 1.527-4.202-7.04z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3233",
    style: {
      fill: "#f10800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m482.915 377.6-1.16 14.035 12.457-1.527 1.913-14.158z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3235",
    style: {
      fill: "#ffd300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m571.788 470.066-6.975 7.275 5.637 19.19 7.352-5.922z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3237",
    style: {
      fill: "#ff5200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m480.701 414.628 2.402 8.814 9.927-1.166-1.54-8.93z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3239",
    style: {
      fill: "#ffe200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m564.813 477.341-6.11 5.253 5.238 17.779 6.509-3.842z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3241",
    style: {
      fill: "#ffb200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m541.146 456.98.94 4.198 6.833 12.55-.297-3.013z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3243",
    style: {
      fill: "#ff5900",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m564.48 408.776-4.29 13.281 9.923 18.328 4.782-12.34z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3245",
    style: {
      fill: "#ff6400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m503.222 423.938 4.202 7.04 9.308 4.075-3.33-6.66z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3247",
    style: {
      fill: "#f20",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m481.755 391.635-1.1 12.383 11.64-1.404 1.917-12.506z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3249",
    style: {
      fill: "#ffc400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m551.933 466.006-3.311 4.709 6.232 15.251 3.85-3.372z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3251",
    style: {
      fill: "#ff3800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m480.654 404.018.048 10.61 10.788-1.283.806-10.73z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3253",
    style: {
      fill: "#ff9400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m570.113 440.385-6.117 10.506 7.792 19.175 6.573-9.333z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3255",
    style: {
      fill: "#d10000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m511.446 362.602-1.749 15.486 13.563 5.884 2.434-15.207z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3257",
    style: {
      fill: "#ff9400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m532.627 445.14 1.674 5.22 7.786 10.818-.94-4.198z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3259",
    style: {
      fill: "#ff6c00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m513.403 428.392 3.329 6.661 9.04 6.52-2.478-6.049z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3261",
    style: {
      fill: "#ff7e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m523.294 435.524 2.478 6.049 8.53 8.788-1.675-5.22z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3263",
    style: {
      fill: "#ff3000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m552.585 392.176-3.724 14.088 11.33 15.793 4.29-13.28z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3265",
    style: {
      fill: "#ff4a00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m491.49 413.345 1.54 8.931 10.192 1.662-.651-8.797z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3267",
    style: {
      fill: "#e80000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m496.125 375.95-1.913 14.158 12.798 2.038 2.687-14.058z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3269",
    style: {
      fill: "#df0000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m525.694 368.765-2.434 15.207 13.176 9.478 3.099-14.736z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3271",
    style: {
      fill: "#ffb200",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m557.518 459.432-5.585 6.574 6.77 16.588 6.11-5.253z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3273",
    style: {
      fill: "#fa0f00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m539.535 378.714-3.099 14.736 12.425 12.814 3.724-14.088z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3275",
    style: {
      fill: "#ffa300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m563.996 450.891-6.478 8.541 7.295 17.91 6.975-7.276z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3277",
    style: {
      fill: "#ff9f00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m543.808 451.066-2.662 5.914 7.476 13.735 3.311-4.709z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3279",
    style: {
      fill: "#ff6800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m560.19 422.057-5.56 11.563 9.366 17.271 6.117-10.506z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3281",
    style: {
      fill: "#ff3000",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m492.296 402.614-.806 10.731 11.08 1.796 1.684-10.605z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3283",
    style: {
      fill: "#ff4a00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m502.57 415.14.652 8.798 10.18 4.454.239-8.415z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3285",
    style: {
      fill: "#ff1a00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m494.212 390.108-1.916 12.506 11.958 1.922 2.756-12.39z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3287",
    style: {
      fill: "#ff7e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m534.546 438.188-1.919 6.953 8.52 11.839 2.661-5.914z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3289",
    style: {
      fill: "#ed0400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m509.697 378.088-2.687 14.058 12.788 5.562 3.462-13.736z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3291",
    style: {
      fill: "#f50",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m513.64 419.977-.237 8.415 9.891 7.132 1.103-7.795z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3293",
    style: {
      fill: "#ff8d00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m548.757 443.301-4.949 7.765 8.125 14.94 5.585-6.574z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3295",
    style: {
      fill: "#ff6800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m524.397 427.73-1.103 7.794 9.333 9.617 1.919-6.953z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3297",
    style: {
      fill: "#ff7a00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m554.63 433.62-5.873 9.681 8.761 16.131 6.478-8.54z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3299",
    style: {
      fill: "#ff4300",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m548.861 406.264-4.92 12.47 10.689 14.886 5.56-11.563z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3301",
    style: {
      fill: "#ff3400",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m504.254 404.536-1.683 10.605 11.07 4.836 2.561-10.231z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3303",
    style: {
      fill: "#fa0f00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m523.26 383.972-3.462 13.736 12.425 8.944 4.213-13.202z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3305",
    style: {
      fill: "#ff1a00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m507.01 392.146-2.756 12.39 11.948 5.21 3.596-12.038z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3307",
    style: {
      fill: "#f20",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m536.436 393.45-4.213 13.202 11.718 12.083 4.92-12.47z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3309",
    style: {
      fill: "#ff6800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m538.764 429.398-4.218 8.79 9.262 12.878 4.949-7.765z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3311",
    style: {
      fill: "#f50",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m543.941 418.735-5.177 10.663 9.993 13.903 5.873-9.681z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3313",
    style: {
      fill: "#ff3b00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m516.202 409.746-2.561 10.23 10.756 7.753 3.415-9.62z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3315",
    style: {
      fill: "#ff4e00",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m527.812 418.109-3.415 9.62 10.149 10.46 4.218-8.791z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3317",
    style: {
      fill: "#ff2500",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m519.798 397.708-3.596 12.038 11.61 8.363 4.411-11.457z",
    clipPath: "url(#peee9962114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3319",
    style: {
      fill: "#ff3800",
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "m532.223 406.652-4.41 11.457 10.951 11.289 5.177-10.663z",
    clipPath: "url(#peee9962114)"
  }))), /*#__PURE__*/React.createElement("defs", {
    id: "defs3327"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "peee9962114",
    style: {
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect3324",
    style: {
      strokeLinecap: "butt",
      strokeLinejoin: "round"
    },
    d: "M139.59 108.432h865.458v695.772H139.59z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrvLogo);
export default __webpack_public_path__ + "static/media/crv-logo.a230ce2ce995ff634bfe141896190f1f.svg";
export { ForwardRef as ReactComponent };